import React, { ReactNode } from 'react';
import { MDSTheme, MDSTypography } from '@marqvision/mds/core';

export enum LanguageEnum {
  Korean = 'ko',
  English = 'en',
}

export const isEndWithConsonant = (korStr: string) => {
  const finalChrCode = korStr.charCodeAt(korStr.length - 1);
  // 0 = 받침 없음, 그 외 = 받침 있음
  const finalConsonantCode = (finalChrCode - 44032) % 28;
  return finalConsonantCode !== 0;
};

export interface ILocalizedStrings {
  // Home
  NeedWorldwideTrademarkFiling: string;
  ARevolutionaryWayToRegisterTrademarks: string;
  GuaranteedRegistrationIsOneClickAway: string; // unused?
  ApplyNow: string;
  ProtectYourTrademark: string;
  ProtectYourTrademark2: string;
  NoHiddenFees: string;
  GetYourTrademarkNow: string;
  WhyFileTrademarkAbroad: string;
  WhyFileTrademarkAbroadDescription: string;
  YourBrandsTrademarkBecomes: string;
  WhatAreTheChallengesOfFilingAbroad: string;
  WhenItComesToRegisteringYourTrademarksAbroad: string;
  ExperienceTheIndustry: string;
  WeOnlyPartnerWithTopTierLawFirmsInEachCountry: string;
  HowDoesItWork: string;
  SubmitYourApplication: string;
  SubmittingAnApplicationOnlyTakes: string;
  LocalLawFirmAssessment: string;
  OurPartnerLawFirmWillReview: string;
  UploadDocuments: string;
  ThroughTheMyApplicationDashboard: string;
  ExaminationByTheTrademarkOffice: string;
  OnAverageFilingToFinalApprovalTakes: string;
  DoneExclamation: string;
  OnceEverythingIsCompletedAnd: string;
  SeeYourInitialQuoteBeforeYouFile: string;
  FreeNoObligationNoCommitment: string;
  WhyMarqFolio: string;
  AreYourTMsAtRiskInChina: string;
  GlobalNetworkOfLeadingPartners: string;
  WeOnlyPartnerWithTopTierLawFirms: string;
  GuaranteedRegistration: string;
  TrademarkRejectionRatesCanBeAsHighAs: string;
  NoAdditionalCosts: string;
  BrandsAreOftenChargedAdditionalHourlyRates: string;
  RealtimeStatusTracking: string;
  TheMARQFolioDashboardAllows: string;
  WhatsInclude: string;
  Pricing: string;
  KeyFeatures: string;
  TrademarkEligibilityCheck: string;
  ConsultationWithLeadingLawFirms: string;
  ApplicationPreparationAndFiling: string;
  GovernmentFeesForApplication: string;
  RealtimeApplicationProgressUpdate: string;
  GovernmentAndServiceFeesForRegistration: string;
  GovernmentAndServiceFeesInCaseOfPreliminaryRejections: string;
  UnlimitedRejectionSupport: string;
  MoneyBackGuarantee: string;
  TenYearTrademarkValidity: string;
  OurStory: string;
  MarqVisionHelpsGlobalBrands: string;
  LearnMore: string;
  EnjoyMoreTransparency: string;
  OurDashboardProvidesYouWith: string;
  GetYourTrademarkFaster: string;
  OurRevolutionaryOnlineProcess: string;
  WorkWithTheBestLocalLawFirms: string;
  OurEliteGlobalNetworkOfTopTierLawFirms: string;
  SaveTimeWithASimpleOnlineProcess: string;
  SubmittingAnApplicationOnlyTakesAFewMinutes: string;
  GovernmentFee: string;
  ServiceFee: string;
  ProtectionPlan: string;
  AreYourTrademarksAtRiskInChina: string;
  DontLoseYourTrademarksToSquatters: string;
  NineDotThreeMillion: string;
  TrademarksRegisteredInChinaIn2020: string;
  ThreeMonths: string;
  YouOnlyHaveThreeMonthsHTML: string;
  FiveYears: string;
  YouMustFileAnInvalidationHTML: string;
  FifteenHundredThousand: string;
  TakingBackYourLostTrademark: string;

  TakeControlOfYourTrademarksInChina: string;
  AutomaticallyReceiveANotification: string;
  SignUpNow: string;
  HasYourTrademarkAlreadyBeenRegisteredInChina: string;
  WeCanHelp: string;
  GetYourTrademarksBackNow: string;
  NPercentDiscountWillBeApplied: (n: number) => string;

  // Header
  FileAnApplication: string;
  MyApplication: string;
  IpManagement: string;
  Profile: string;
  Login: string;

  // Sign In Up
  DoYouHaveAccount: string;
  Yes: string;
  No: string;
  IHaveMarqCommerceAccount: string;
  YouMustCreateSeperateAccount: string;
  IAlreadySignedUp: string;
  INeverSignedUp: string;
  EmailAddress: string;
  Password: string;
  CantFindAccount: string;
  IncorrectPassword: string;
  ForgotPassword: string;
  LoginSuccessful: string;
  SignUpSuccessful: string;
  VerifyEmailSending: string;
  VerifyEmailSent: string;
  VerifyEmail: string;
  EnterValidEmail: string;
  SendAgainAfterNSeconds: (timer: number) => string;
  ResendVerifyEmail: string;
  ToConfirmYour: string;
  GoToYourEmail: string;
  ReturnToThisScreen: string;
  CompleteVerification: string;
  Checking: string;
  VerificationIncomplete: string;
  Verified: string;
  MoreThan8Char: string;
  IncludeAtLeast1Letter: string;
  PasswordConfirmation: string;
  Confirmed: string;
  ResetPasswordAndLoggingIn: string;
  ResetPasswordAndLogin: string;
  SigningUp: string;
  SignUp: string;
  LoggingIn: string;
  EmailDoesNotExist: string;
  EmailAlreadyRegistered: string;
  ReferralCode: string;
  SignInToYourAccount: string;
  NewToMARQFolio: string;
  CreateAnAccount: string;
  // BottomAction
  Prev: string;
  SaveTemporarily: string;
  AutoSaved: string;
  Submit: string;
  Next: string;
  Continue: string;
  NotVerified: string;

  // Step1 File an application
  SelectCountries: string;
  WhereDoYouWishToFileYourTrademark: string;
  NCountriesSelected: (countries: number) => string;
  FrequentlySelected: string;
  Search: string;
  CantFindWhat: string;
  LookingForATrademark: string;
  PleaseListOut: string;
  EnterTheCountry: string;
  Country123: string;
  AddCountries: string;

  // Step 2 Type
  SelectType: string;
  TrademarkTips: string;
  ChooseAgain: string;
  Word: string;
  EnterTheWord: string;
  UploadYourLogo: string;
  UploadYourComposite: string;
  WordTrademarkTips: string;
  MakeUpYourOwn: string;
  AvoidGeneric: string;
  IfYouWishToFileInChina: string;
  LogoTrademarkTips: string;
  ChooseALogoMark: string;
  CompositeTrademarkTips: string;
  ItIsRecommendToRegister: string;
  EnterTheWordElement: string;
  Logo: string;
  Composite: string;
  ProvidesTheBroadestLevelOfProtection: string;
  ProvidesProtectionForYourBrand: string;
  ProvidesProtectionForBoth: string;
  PleaseEnterWordToRegister: string;
  IsStylized: string;
  StylizedWord: string;
  UnstylizedWord: string;
  PleaseUploadWordmark: string;
  PleaseUploadLogo: string;
  PleaseEnterPortion: string;
  PleaseUploadCompositeMark: string;
  ReUploadImage: string;
  UploadImage: string;
  ImageSupport: string;
  FileIsLarge: string;
  AllowFileType: string;
  TheReason: string;
  PossibleRejectionCases: string;
  IndistinctiveTrademark: string;
  PureDescriptiveTrademark: string;
  Copycat: string;
  DescriptionOfYourTrademark: string;
  TypeOfYourTrademark: string;
  WordTrademarkYouWish: string;
  ImageOfYourStylized: string;
  ImageOfYourLogoMark: string;
  ImageOfYourCompositeMark: string;
  NeedHelpChoosingATrademarkType: string;
  IfYouWishToFileMoreThan: string;
  IfYouAreNotSureWhichTypeToChoose: string;

  // Step 3
  WhatGoodsOrServiceUse: string;
  SearchByKeywordsOrClassNumber: string;
  BreadCosmeticsClass: string;
  PleaseListOnlyUsingProducts: string;
  UpTo200Char: string;
  NSelected: (n: number) => string;
  SelectAll: string;
  Clear: string;
  SelectClasses: string;

  // Step 4
  PleaseShareWebsiteOrMaterials: string;
  Optional: string;
  OR: string;
  UploadFile: string;
  UpTo6Files: string;
  EnterUrl: string;
  AddMoreUrl: string;
  ShareAnyInformation: string;
  YouCanAddUpToSixHTML: string;

  // Profile
  OwnerType: string;
  Individual: string;
  Company: string;
  LegalNameOfIndividualOwner: string;
  LastName: string;
  FirstName: string;
  Nationality: string;
  Country: string;
  CompanyName: string;
  CountryCorporated: string;
  PhoneNumber: string;
  CountryNumber: string;

  // Step 6
  ApplicationDetails: string;
  ApplicantDetails: string;
  CountryOfApplication: string;
  TrademarkType: string;
  TrademarkDescription: string;
  ReferencesOfTrademarkUsages: string;
  ReferencesOfYourTrademarkUsedInGoodsOrServices: string;
  PleaseProvideReferences: string;
  UpdateMyInfo: string;
  EstimatedPrice: string;
  TotalPrice: string;
  PriceEstimationIs: string;
  AddMoreCountries: string;
  AddNMoreCountries: (n: number, p: number) => string;
  NPercentsMultiCountryDiscount: (n: number) => string;
  NPercentsSecondAppDiscount: (n: number) => string;
  NPercentsAdditionalDiscount: (n: number) => string;
  NClasses: (n: number) => ReactNode;
  FirstClass: string;
  EachAdditionalClass: string;
  NAdditionalClasses: (n: number) => string;
  IncludeOneClass: (n: number) => string;
  OtherCountriesYouWishToRegister: string;
  GoodsAndServices: string;
  GoodsAndServicesYouOffer: string;
  SelectByCountry: string;
  AddMoreClasses: string;
  EditClass: string;
  Trademark: string;
  WhoIsTheIntended: string;
  ViewEstimatedPrice: string;
  Documents: string;

  // Finished
  Submitted: string;
  WeWillGetBack: string;
  AnotherApplication: string;
  FileANewApplication: string;
  WhatAreTheNextSteps: string;
  YourPaymentIsConfirmedBy: string;
  YouSubmitInformationAnd: string;
  WeWillNowStart: string;
  LawFirmsReviewAll: string;
  IpOfficesExamineTheApplication: string;
  IpOfficesAnnounceFinalResults: string;
  FileAnotherApplication: string;
  FileAnotherApplicationAndSaveNPercent: (n: string) => string;
  CheckYourApplicationStatus: string;
  ThankYouForYourPayment: string;
  ThankYouPayment: string;
  ThankYouPaymentDesc1: (onClick: () => void) => React.ReactNode;
  ThankYouPaymentDesc2: string;
  ThankYouPaymentDesc3: string;
  ThankYouPaymentDesc4: string;
  ThankYouPaymentCompleted: string;
  ThankYouPaymentCompletedDesc: string;
  YourTrademarkApplicationIsUnderPreparation: string;
  PleaseCompleteYourPayment: string;
  ThankYouForYourOrder: string;
  DocumentsAndQuestionnaires: string;
  DocumentsDescriptions1: string;
  DocumentsDescriptions2: string;
  DocumentsProgressDone: (value: number, total: number) => string;
  DocumentsProgressAllSet: (value: number, total: number) => string;
  DocumentsPoa: (v: string) => string;
  DocumentsPleaseSignThisForm: string;
  DocumentsSubmitted: string;
  DocumentsFullName: string;
  DocumentsFullNamePlaceholder: string;
  DocumentsPoaSignAgree: string;
  DocumentsPoaSign: string;
  DocumentsPoaSignedSuccessfully: string;
  DocumentsRejectedDownloadLatest: string;
  DocumentsUpload: string;
  DocumentsSubmittedThisDoc: string;
  DocumentsEnterYourReplyHere: string;
  DocumentsSaving: string;
  DocumentsOther: string;
  DocumentsPartneredWith: (v: string) => string;
  DocumentsNoPartnerInfo: string;
  DocumentsStatusCompleted: string;
  DocumentsStatusReviewRequired: string;
  DocumentsViewForm: string;
  DocumentsSubmitRequiredQnaDocs: string;
  DocumentsReviewYourDocs: string;
  ApplicationCollectingDocuments: string;
  DocumentsNoDocumentsRequested: string;
  DocumentsHasBeenSigned: string;
  FinishedWarningPopupTitle: string;
  FinishedWarningPopupDest: string;
  FinishedWarningPopupStay: string;
  FinishedWarningPopupContinue: string;
  Leave: string;

  // Account
  LoginSuccessAndAutoSaved: string;

  // Navigation Form
  DoYouWantToLeave: string;

  //region>> MyApplication
  // MyApplication: string;
  Applications: string;
  ApplicationId: string;
  ApplicationCount: (count: number) => React.ReactNode;
  NoApplications: string;
  SubmittedDateNewest: string;
  SubmittedDateOldest: string;
  UpdatedDateNewest: string;
  UpdatedDateOldest: string;
  LastSavedDate: string;
  SubmittedDate: string;
  DateFormat: string;
  DateFormatSlash: string;
  SeeDetail: string;
  Apply: string;
  ContractAndPayment: string;
  EligibilityCheck: string;
  PaymentRequested: string;
  PaymentSuccess: string;
  PaymentWaiting: string;
  PaymentFailed: string;
  PaymentCanceled: string;
  PaymentOverdue: string;
  PaymentIncomplete: string;
  Preparation: string;
  File: string;
  Examination: string;
  FinalDecision: string;
  Resume: string;
  FinalRejection: string;
  PublishForOppposition: string;
  OppositionPending: string;
  RegistrationGranted: string;
  RegistrationCompleted: string;
  Filed: string;
  UnderExamination: string;
  PreliminarilyRejected: string;
  AmendmentSubmitted: string;
  AppealingRefusal: string;
  OvercomingMarks: string;
  OvercameMarks: string;
  FailedMarks: string;
  FilingPending: string;
  ConfirmingApplication: string;
  PreparingToFile: string;
  StatusOfCountryUpdated: (countries: string, plural?: boolean) => string;
  NewRequestFrom: (from: string, countries: string) => string;
  Select: string;
  Enter: string;
  ApplicationStatus: string;
  Request: string;
  invoice: string;
  NoNewRequest: string;
  DueDateClosest: string;
  CreatedDate: string;
  AdditionalInformation: string;
  TrademarkClasses: string;
  ClassNumber: (number: number | string) => string;
  TrademarkUsageHistory: string;
  AreYouSoldInUS: string;
  WhenIsFirstInUs: string;
  IDontKnow: string;
  WhenIsDateOfFirst: string;
  ReplyAndAttachFile: string;
  Reply: string;
  ChooseMultipleOption: string;
  ChooseAnOption: string;
  DueOn: (deadline: string, timezone?: string) => string;
  OverDue: (overdue: number) => string;
  Send: string;
  Sending: string;
  Other: string;
  OtherDirect: string;
  DateFormatWithTime: string;
  YouCanOnlyAttachUpToNFiles: (max: number) => string;
  YouCanAttachFile: (max: number) => string;
  ApplicationHasBeenUpdated: string;
  LastEditedDate: string;
  CompletePayment: string;
  TryAgain: string;
  YourPaymentHasExpired: string;
  CountriesAndClasses: string;
  OwnerAndInvoiceDetails: string;
  BillingDetails: string;
  BillingDetailsMatch: string;
  PermanentResidence: string;
  StreetAddress: string;
  City: string;
  ZipPostalCode: string;
  PaymentMethod: string;
  SelectYourPreferredPaymentMethod: string;
  CreditOrDebitCard: string;
  BankTransfer: string;
  Cardholder: string;
  CardNumber: string;
  ExpirationDate: string;
  CVVCVC: string;
  SaveCardForLaterUse: string;
  PayN: (n: string) => string;
  ByClickingTheXButtonJSX: (x: string, onTermsClick: () => void, onPrivacyClick: () => void) => JSX.Element;
  NewCreditOrDebitCard: string;
  Summary: string;
  AbovePriceIsValidUntil: (d: string) => string;
  PlaceAnOrder: string;
  Order: string;
  AccountHolder: string;
  AccountNumber: string;

  AccountID: string;
  RoutingNumber: string;
  SwiftCode: string;
  BankName: string;
  BankAddress: string;
  Copy: string;
  CopiedToClipboard: string;
  ReferenceNumber: string;
  DueDate: string;
  DownloadInvoice: string;
  YourTrademark: string;
  TypeOfTrademark: string;
  SorryWeCannotProcess: string;
  AreYouSureWantToDelete: string;
  ResumeApplication: string;

  ContactDetails: string;
  EnglishName: string;
  EnglishNameBusiness: string;
  LegalNameOfCompany: string;
  Address: string;
  ChineseAddress: string;
  WriteItMyself: string;
  RequestTranslation: string;
  OurPartnerLawFirmWillTranslate: string;
  IConsentUsingTranslated: string;
  EnglishAddress: string;
  EnglishAddressBusiness: string;

  PaymentInProgress: string;
  AdditionalPaymentInProgress: string;
  AdditionalPayment: string;
  Recovery: string;
  //endregion

  //region>> Profile Page
  Change: string;
  Save: string;
  Cancel: string;
  Logout: string;
  Payment: string;
  SavedCreditOrDebitCards: string;
  AddNewCreditOrDebitCard: string;
  EndingInN: (n: string) => string;
  AddNewCard: string;
  PleaseEnterAValidCardNumber: string;
  PleaseEnterAValidExpiryDate: string;
  PleaseEnterAValidCVVNumber: string;
  HowToFindYourCVVCVCHTML: string;
  Delete: string;
  WordTrademark: string;
  LogoTrademark: string;
  CompositeTrademark: string;
  ShowDetails: string;
  HideDetails: string;
  Countries: string;
  Classes: string;
  Class: string;

  //endregion

  // doc name by step
  SendReport: string;
  Contract: string;
  FilingSendReport: string;
  FileDoneReport: string;
  OaReport: string;
  OaCaNoti: string;
  OppReport: string;
  OppReqInfo: string;
  OppReqDone: string;
  OppResultReport: string;
  AppReport: string;
  AppLose: string;
  AppWin: string;
  RejectReport: string;
  RegReport: string;
  RegDoneReport: string;
  RegElecReport: string;
  CertSend: string;
  CertAnnDone: string;
  RetrievalInfo: string;
  RetrievalDone: string;
  RetrievalReqReceive: string;
  RetrievalReqDone: string;
  RetrievalWin: string;
  RetrievalLose: string;

  // Consent
  Consent: (eventTerm: () => void, eventPP: () => void) => React.ReactNode;

  // VerifyPage
  EmailVerified: string;
  PleaseCloseThisScreen: string;

  // Misc
  Add: string;
  ConfirmedPrice: string;
  DragAndDropFiles: string;
  Max20mb: string;
  ClickHereToBrowse: string;

  // Payment
  PaymentInvalidConflict: string;

  // Watch
  Watch: string;
  WatchStartDate: string;
  GetStartedByAdding: string;
  BeAlertedWhenAThirdPartyTries: string;
  AddNewTrademarkToWatch: string;
  Table: string;
  TrademarkOverview: string;
  TmOverView: string;
  NewTrademark: string;
  WatchCount: (count: number) => React.ReactNode;
  NewTrademarkWatch: string;
  EnterTrademarkName: string;
  TrademarkName: string;
  TrademarkImage: string;
  CountryToWatch: string;
  SelectCountry: string;
  SelectWatchStartDate: string;
  WatchPeriod: string;
  SelectPeriod: string;
  ByCheckingTheBox: string;
  AddTrademarkToWatch: string;
  DragAndDropOrBrowse: string;
  Period: string;
  Status: string;
  StatusDetails: string;
  YourRequestIsBeing: string;
  EverythingLooksGreat: string;
  TakeAction: string;
  RemindMeLater: string;
  WatchStartDateDesc: string;
  WatchStartDateAsc: string;
  UrgencyDesc: string;
  OneMonths: string;
  SixMonths: string;
  OneYear: string;
  ThreeYear: string;
  WatchCancel: string;
  logo: string;
  word: string;
  composite: string;
  designRight: string;
  ExpectedCompletion: string;
  ExpectedCompletionDescription: string;
  LogoMark: string;

  FilingApplication: string;
  ApplicationInReview: string;
  AwaitingTrademark: string;
  TrademarkRegistered: string;
  RequestInProgress: string;
  EvaluationInProgress: string;
  WaitingForPayment: string;
  PreparingApplication: string;
  ApplicationDrafted: string;
  ApplicationDraftConfirmed: string;
  ApplicationFiled: string;
  PreliminarilyRefused: string;
  DefendingRefusal: string;
  PublishedForOpposition: string;
  ApplicationOpposed: string;
  AppealingAgainstRejection: string;
  WaitingForAdditionalPayment: string;
  AdditionalPaymentFailed: string;
  AdditionalPaymentCanceled: string;
  ApplicationRejected: string;
  TrademarkApplication: string;
  RetrievingConflictingMarks: string;
  RetrievingTradeMarks: string;
  ConflictingMarksRetrieved: string;
  RetrievalFailed: string;
  ReadMore: string;
  ShowLess: string;
  ContinueToBillingDetails: string;
  SaveAndContinue: string;
  SignAndContinue: string;
  Edit: string;

  OrderForm: string;
  OrderFormDesc: string;
  ConfirmFullName: string;
  ConfirmLegalName: string;
  OrderFormSign: (onClickTerms: () => void, onClickPP: () => void) => React.ReactNode;
  DoYouWantToLeavePayment: string;

  PleaseSignIn: string;
  ToContinueTo: (pageName: string) => string;
  ThisPage: string;

  // Recovery step
  OppInfo: string;
  OppReq: string;
  OppDone: string;
  OppResp: string;
  OppRedo: string;
  OppRedoDone: string;
  ResultReceive: string;
}

const LocalizedStrings: { [lang: string]: ILocalizedStrings } = {
  [LanguageEnum.English]: {
    NeedWorldwideTrademarkFiling: 'Need Worldwide Trademark Filing?',
    ARevolutionaryWayToRegisterTrademarks: 'A revolutionary way to<br />register trademarks abroad',
    GuaranteedRegistrationIsOneClickAway: 'Guaranteed Registration is<br />One Click Away',
    ApplyNow: 'Apply now',
    ProtectYourTrademark: 'Protect your trademark with worldwide registration and no hidden fees, ever.',
    ProtectYourTrademark2: 'Protect your trademark with worldwide registration and',
    NoHiddenFees: 'No hidden fees, ever',
    GetYourTrademarkNow: 'Get your trademark now',
    WhyFileTrademarkAbroad: 'Why file trademarks abroad?',
    WhyFileTrademarkAbroadDescription:
      'In today’s digital economy, businesses of all sizes are expanding to the global marketplace. As our world becomes smaller, an international trademark strategy will become an important component of protecting your brand’s value, revenue, and intellectual property (IP) on the global stage.<br /><br />Successfully applying for trademark rights in your home country will not automatically provide you with international protection. Most countries operate under the principle of first-to-file. This means if you do not file for foreign trademark registrations early enough, someone else can lawfully own that same trademark in another country.<br /><br />Losing your trademarks not only leads to great revenue loss but also hurts your brand value. Just as you have taken steps to protect your trademarks domestically, you should also consider taking action to safeguard your assets abroad.',
    YourBrandsTrademarkBecomes:
      'Your brand’s trademark becomes the biggest weapon to protect your business against international competitors and copycats trying to use your hard work and reputation to their advantage.',
    WhatAreTheChallengesOfFilingAbroad: 'What are the challenges of filing abroad?',
    WhenItComesToRegisteringYourTrademarksAbroad:
      'When it comes to registering your trademarks abroad, many rights owners often find themselves overwhelmed when navigating the complex process of filing for non-domestic trademarks.<br /><br />Finding a reliable local law firm in each country can be difficult, expensive, and time-consuming leaving rights owners wondering what their best option is.',

    ExperienceTheIndustry: "Experience the industry's best way to register trademarks wherever you need them",
    WeOnlyPartnerWithTopTierLawFirmsInEachCountry:
      'We only partner with top-tier law firms in each country, so you have access to the best local law firms around the world.<br/><br/>Using our simple online application, you can submit within minutes and check your filling status anytime on our easy-to-use dashboard — no need to call or send emails to check the progress of your application!',
    HowDoesItWork: 'How does it work?',
    SubmitYourApplication: 'Submit your application',
    SubmittingAnApplicationOnlyTakes:
      "Submitting an application only takes a few minutes and you'll get your initial quote right away.",
    LocalLawFirmAssessment: 'Local law firm assessment',
    OurPartnerLawFirmWillReview:
      'Our partner law firm will review your application and get back to you with in-depth analysis and recommendations',
    UploadDocuments: 'Upload documents',
    ThroughTheMyApplicationDashboard:
      'Through the “My application” dashboard, you can see a list of required documents to upload and check your application’s real-time status.',
    ExaminationByTheTrademarkOffice: 'Examination by the trademark office',
    OnAverageFilingToFinalApprovalTakes:
      'On average, filing to final approval takes 6 to 12 months depending on which country(s) you are registering for.',
    DoneExclamation: 'Done!',
    OnceEverythingIsCompletedAnd:
      'Once everything is completed and your trademark is approved, you will receive the Certificate of Registration and relevant documents.<br/><br/>Congrats! Your trademark is officially now yours!',
    SeeYourInitialQuoteBeforeYouFile: 'See your initial quote before you file',
    FreeNoObligationNoCommitment: 'Free  ·  No obligation  ·  No commitment',
    WhyMarqFolio: 'Why MARQ Folio?',
    AreYourTMsAtRiskInChina: "Are your TM's at risk in China?",
    GlobalNetworkOfLeadingPartners: 'Global network of<br />leading partners',
    WeOnlyPartnerWithTopTierLawFirms:
      'We only partner with top-tier law firms in each country. Through this leading partner network, brands are able to enjoy high-quality advice at a reasonable price.',
    GuaranteedRegistration: 'Guaranteed registration',
    TrademarkRejectionRatesCanBeAsHighAs:
      'Trademark rejection rates can be as high as 75% in some countries. Overcoming these rejections is expensive and costs brands invaluable time. Feel confident filing with unlimited rejection support and a money-back guarantee if your application is rejected.',
    NoAdditionalCosts: 'No additional costs or hidden fees, ever',
    BrandsAreOftenChargedAdditionalHourlyRates:
      'Brands are often charged additional hourly rates for support, making the final price unpredictable. MARQ Folio offers inclusive pricing with no hidden fees.',
    RealtimeStatusTracking: 'Real-time status tracking',
    TheMARQFolioDashboardAllows:
      'The MARQ Folio dashboard allows you to check the progress of all your submissions in real time.',
    WhatsInclude: 'What’s included in the price?',
    Pricing: 'Pricing',
    KeyFeatures: 'Key Features',
    TrademarkEligibilityCheck: 'Trademark eligibility check',
    ConsultationWithLeadingLawFirms: 'Consultation with leading law firms',
    ApplicationPreparationAndFiling: 'Application preparation and filing',
    GovernmentFeesForApplication: 'Government fees for application',
    RealtimeApplicationProgressUpdate: 'Real-time application progress updates',
    GovernmentAndServiceFeesForRegistration: 'Government & service fees for registration',
    GovernmentAndServiceFeesInCaseOfPreliminaryRejections:
      'Government & service fees in case of preliminary rejections',
    UnlimitedRejectionSupport: 'Unlimited rejection support',
    MoneyBackGuarantee: 'Money-back guarantee if your trademark is rejected',
    TenYearTrademarkValidity: '10-year trademark validity',
    OurStory: 'Our Story',
    MarqVisionHelpsGlobalBrands:
      'MarqVision helps global brands identify and remove counterfeits from over 1,500 online marketplaces worldwide. Counterfeiting is a massive and growing threat across the world. MarqVision is on a mission to protect creativity and innovation with technology that allows brands to automatically monitor and protect their IPs. Harnessing image recognition and natural language processing, this AI-powered SaaS makes it faster than ever to take down counterfeits.<br /><br />MarqVision was founded in 2020 by Harvard Law graduates and is backed by DST Global Partners, Softbank, Atinum Investments, Bass Investment, and Y Combinator. The recipient of a prestigious 2022 Innovation Award from LVMH Moët Hennessy Louis Vuitton (LVMH), MarqVision is also part of the LVMH accelerator program, La Maison des Startups, at the Station F incubator. MarqVision is bringing forth the next evolution of brand protection for businesses everywhere.',
    LearnMore: 'Learn more: ',
    EnjoyMoreTransparency: 'Enjoy more transparency',
    OurDashboardProvidesYouWith:
      'Our dashboard provides you with one centralized location to check and manage the progress of all your applications in real-time.',
    GetYourTrademarkFaster: 'Get your trademarks faster',
    OurRevolutionaryOnlineProcess:
      'Our revolutionary online process optimizes communication, reducing your time and cost for filing.',
    WorkWithTheBestLocalLawFirms: 'Work with the best local law firms',
    OurEliteGlobalNetworkOfTopTierLawFirms:
      'Our elite global network of top-tier law firms specialize in local trademark laws so you can file with confidence.',
    SaveTimeWithASimpleOnlineProcess: 'Save time with a simple online process',
    SubmittingAnApplicationOnlyTakesAFewMinutes:
      'Submitting an application only takes a few minutes and our intuitive application module will walk you through every step.',

    GovernmentFee: 'Government fee',
    ServiceFee: 'Service fee',
    ProtectionPlan: 'Protection plan',

    AreYourTrademarksAtRiskInChina: 'Are your trademarks at risk in China?',
    DontLoseYourTrademarksToSquatters: "Don't lose your trademarks to squatters.",
    NineDotThreeMillion: '9.3M',
    TrademarksRegisteredInChinaIn2020: 'trademarks registered in China in 2020',
    ThreeMonths: '3 months',
    YouOnlyHaveThreeMonthsHTML:
      'You only have <b>3 months to file an opposition</b> after the publication of a squatted trademark',
    FiveYears: '5 years',
    YouMustFileAnInvalidationHTML:
      "You must file an <b>invalidation within 5 years</b> of the squatted trademark's registration",
    FifteenHundredThousand: '$150,000',
    TakingBackYourLostTrademark:
      'Taking back your lost trademark can cost an <b>average of $150,000 USD</b> and takes at least a year',
    TakeControlOfYourTrademarksInChina: 'Take control of your trademarks in China',
    AutomaticallyReceiveANotification:
      'Automatically receive a notification when your trademark has been submitted for registration by squatters in China.',
    SignUpNow: 'Sign up now',
    HasYourTrademarkAlreadyBeenRegisteredInChina: 'Has your trademark already been registered in China?',
    WeCanHelp: 'We can help! Our experienced partners specialized in recapturing squatted trademarks.',
    GetYourTrademarksBackNow: 'Get your trademarks back now',
    NPercentDiscountWillBeApplied: (n: number) => `${n}% discount will be applied automatically at checkout`,
    FileAnApplication: 'File an application',
    MyApplication: 'My application',
    IpManagement: 'IP management',
    Profile: 'Profile',
    Login: 'Sign in',
    DoYouHaveAccount: 'Do you have a MARQ Folio account?',
    Yes: 'Yes',
    No: 'No',
    IHaveMarqCommerceAccount: 'I have a MARQ Commerce / Contents account',
    YouMustCreateSeperateAccount:
      "Note that you'll need to create a separate MARQ Folio account,<br />even if you've already registered on MARQ Commerce or MARQ Content",
    IAlreadySignedUp: 'Already have a MARQ Folio account? Sign in',
    INeverSignedUp: 'I never signed up.',
    EmailAddress: 'Email',
    Password: 'Password',
    CantFindAccount: "We can't find an account with this email address. Please try again or create a new account.",

    IncorrectPassword: 'Incorrect password. Please try again or reset your password.',
    ForgotPassword: 'Forgot your password?',
    LoginSuccessful: 'Successfully signed in!',
    SignUpSuccessful: 'Successfully registered!',
    VerifyEmailSending: 'Sending verification email',
    VerifyEmailSent: 'Verification email sent',
    VerifyEmail: 'Verify your email',
    EnterValidEmail: 'Please enter a valid email address',
    SendAgainAfterNSeconds: (timer) => `Resend after ${timer} seconds`,
    ResendVerifyEmail: 'Resend verification email',
    ToConfirmYour: 'To confirm your email address.',
    GoToYourEmail: '1. Please click on the link in the verification email',
    ReturnToThisScreen: '2. Return to this screen and complete verification',
    CompleteVerification: 'Complete verification',
    Checking: 'Checking',
    VerificationIncomplete: 'Verification incomplete. Please check inbox or email address.',
    Verified: 'Verified',
    MoreThan8Char: 'More than 8 characters',
    IncludeAtLeast1Letter: 'Include at least 1 letter, 1 special character and 1 number',
    PasswordConfirmation: 'Confirm password',
    Confirmed: 'Confirmed',
    ResetPasswordAndLoggingIn: 'Reset password and logging in',
    ResetPasswordAndLogin: 'Reset password and sign in',
    SigningUp: 'Signing up',
    SignUp: 'Create account',
    LoggingIn: 'Logging in',
    EmailDoesNotExist: 'This email account does not exist. Please try again or sign-up.',
    EmailAlreadyRegistered: 'This email is already registered. Please sign in.',
    ReferralCode: 'Referral Code (optional)',
    SignInToYourAccount: 'Sign in to your account',
    NewToMARQFolio: 'New to MARQ Folio?',
    CreateAnAccount: 'Create an account',
    Prev: 'Prev',
    SaveTemporarily: 'Save Temporarily',
    AutoSaved: 'Auto-saved',
    Submit: 'Submit',
    Next: 'Next',
    Continue: 'Continue',
    NotVerified: 'Not yet verified',

    SelectCountries: 'Select the countries in which you wish to register your trademark.',
    WhereDoYouWishToFileYourTrademark: 'Where do you wish to file your trademark?',
    NCountriesSelected: (countries) => `${countries} ${countries > 1 ? 'countries' : 'country'}`,
    FrequentlySelected: 'Frequently selected',
    Search: 'Search',
    CantFindWhat: 'Can’t find what you’re looking for?',
    LookingForATrademark: 'Looking for a trademark in countries not listed here?',
    PleaseListOut: "Please list out the countries below. We'll get back to you shortly",
    EnterTheCountry: "Enter the countries you're hoping to register. We'll get back to you shortly.",
    Country123: 'Country 1, Country 2, Country 3',
    AddCountries: 'Add countries',
    SelectType: 'Select the type of trademark you wish to register',
    TrademarkTips: 'Trademark tips',
    ChooseAgain: 'Choose again',
    Word: 'Word',
    EnterTheWord: 'Enter the word you wish to register',
    UploadYourLogo: 'Upload your logo trademark',
    UploadYourComposite: 'Upload your composite trademark',
    WordTrademarkTips: 'Word trademark tips',
    MakeUpYourOwn: 'Make up your own business name (like Microsoft)',
    AvoidGeneric: 'Avoid generic or self-descriptive names (like Delicious BBQ, Frozen Yogurt)',
    IfYouWishToFileInChina:
      'If you wish to file in China, try not to include a specific location name (like Boston Chowder)',
    LogoTrademarkTips: 'Logo trademark tips',
    ChooseALogoMark:
      'Choose a logo mark that isn’t confusingly similar to any existing (already filed or registered) marks',
    CompositeTrademarkTips: 'Composite trademark tips',
    ItIsRecommendToRegister:
      'It is recommended to register your word and logo trademark separately for complete protection. Even seemingly small changes to a design, such as a brand name moving to the side of a graphic instead of resting on top of it, could warrant filing a new trademark application.',
    EnterTheWordElement: 'Enter the word element in your mark',
    Logo: 'Logo',
    Composite: 'Composite',
    ProvidesTheBroadestLevelOfProtection:
      "Provides the broadest level of protection for your brand's name used in any form, regardless of style, design, font, or color",
    ProvidesProtectionForYourBrand:
      "Provides protection for your brand's identifying design and visual elements (without any text) including all color variations",
    ProvidesProtectionForBoth: 'Provides protection for both the visual elements and the stylized name of your brand',
    PleaseEnterWordToRegister: 'Please enter the word you wish to register.',
    IsStylized: 'Is your wordmark stylized?',
    StylizedWord: 'Stylized wordmark',
    UnstylizedWord: 'Unstylized wordmark',
    PleaseUploadWordmark: 'Please upload the image of your stylized wordmark.',
    PleaseUploadLogo: 'Please upload the image of your logo mark.',
    PleaseEnterPortion: 'Please enter the word portion in your mark.',
    PleaseUploadCompositeMark: 'Please upload the image of your composite mark.',
    ReUploadImage: 'Re-upload Image',
    UploadImage: 'Upload Image',
    ImageSupport: 'Only image files are supported (JPG, JPEG, HEIC, GIF, PNG). Maximum size is 20MB.',
    FileIsLarge: 'Maximum size is 20MB',
    AllowFileType: 'Only image files or PDF are supported (JPG, JPEG, HEIC, GIF, PNG, PDF).',
    TheReason: 'The reason for having a trademark is to differentiate you among competitors.',
    PossibleRejectionCases: 'Possible rejection cases',
    IndistinctiveTrademark: 'Indistinctive trademark',
    PureDescriptiveTrademark: 'Purely descriptive trademark',
    Copycat: 'Copycat',
    WhatGoodsOrServiceUse: 'What goods or services do you offer using the trademark?',
    SearchByKeywordsOrClassNumber: 'Search by keywords or Class numbers',
    BreadCosmeticsClass: 'Bread, Cosmetics, Class 1, Class 43',
    PleaseListOnlyUsingProducts: 'Please list only the products and services you are using or intending to use.',
    UpTo200Char: 'Up to 200 characters can be entered.',
    NSelected: (n: number) => `${n} Selected`,
    SelectAll: 'Select All',
    Clear: 'Clear',
    SelectClasses: 'Select Classes',
    PleaseShareWebsiteOrMaterials: 'Please share your website or materials that explain your goods or services.',
    Optional: 'Optional',
    OR: 'OR',
    UploadFile: 'Upload File',
    UpTo6Files: 'Up to 6 URLs or Files',
    EnterUrl: 'Enter URL',
    AddMoreUrl: 'Add more URL',
    ShareAnyInformation: 'Share any information that explains your products or services',
    YouCanAddUpToSixHTML:
      'You can add up to six materials, such as intro deck about your company, links to your website, social media, or Amazon store',
    OwnerType: 'Owner type',
    Individual: 'Individual',
    Company: 'Company',
    LegalNameOfIndividualOwner: 'Legal name of individual owner',
    LastName: 'Last name',
    FirstName: 'First name',
    Nationality: 'Nationality of owner',
    Country: 'Country',
    CompanyName: 'Legal name of company',
    CountryCorporated: 'Country corporated',
    PhoneNumber: 'Phone Number',
    CountryNumber: 'Country number',
    ApplicationDetails: 'Application details',
    ApplicantDetails: 'Applicant details',
    CountryOfApplication: 'Country of application',
    TrademarkType: 'Trademark type',
    TrademarkDescription: 'Trademark description',
    ReferencesOfTrademarkUsages: 'References of trademark usages',
    ReferencesOfYourTrademarkUsedInGoodsOrServices: 'References of your trademark used in goods or services.',
    PleaseProvideReferences: 'Please provide references of your trademark used in goods or services.',
    UpdateMyInfo: 'Update my account information with this.',
    EstimatedPrice: 'Estimated Price',
    TotalPrice: 'Total',
    PriceEstimationIs:
      "Price estimation is currently unavailable for this country. We'll response to your request shortly.",
    AddMoreCountries: 'Add more countries',
    AddNMoreCountries: (n: number, p: number) => `Select ${n} countr${n > 1 ? 'ies' : 'y'} and save ${p}%`,
    NPercentsMultiCountryDiscount: (n: number) => `${n}% Multi-country discount`,
    NPercentsSecondAppDiscount: (n: number) => `${n}% Second submission discount`,
    NPercentsAdditionalDiscount: (n: number) => `${n}% Additional discount`,
    NClasses: (n: number) => (
      <>
        <span>{n}</span> Class{n == 1 ? '' : 'es'}
      </>
    ),
    FirstClass: 'First Class',
    EachAdditionalClass: 'Each additional Class',
    NAdditionalClasses: (n: number) => `${n > 1 ? `${n} additional Classes` : `Additional Class`}`,
    IncludeOneClass: (n: number) => `Includes 1 Class, each additional Class costs ${n}.`,
    OtherCountriesYouWishToRegister: 'Other countries you wish to register',
    GoodsAndServices: 'Goods and services',
    GoodsAndServicesYouOffer: 'Goods and services you offer using the trademark',
    SelectByCountry: 'Select by country',
    AddMoreClasses: 'Add more Classes',
    EditClass: 'Edit Class',
    Trademark: 'Trademark',
    WhoIsTheIntended: 'Who is the intended owner of the trademark?',
    ViewEstimatedPrice: 'View Estimated Price',
    Documents: 'Documents',

    DescriptionOfYourTrademark: 'Description of your trademark',
    TypeOfYourTrademark: 'Type of your trademark',
    SorryWeCannotProcess: 'Sorry, we cannot process your payment at the moment.',
    AreYouSureWantToDelete: 'Are you sure you want to delete this application?',
    ResumeApplication: 'Resume application',

    ContactDetails: 'Contact details',
    EnglishName: 'English name written on identification (e.g. passport, social security card)',
    EnglishNameBusiness:
      'English name written on business entity documentation (e.g. certificate of incorporation, tax registration certificate)',
    LegalNameOfCompany: 'Legal name of company',
    Address: 'Address',
    ChineseAddress: 'Chinese Address',
    WriteItMyself: 'Write it myself',
    RequestTranslation: 'Request translation',
    OurPartnerLawFirmWillTranslate:
      'Our partner law firm will translate your English address written above and use it in the application',
    IConsentUsingTranslated: 'I consent to using a translated address',
    EnglishAddress: 'English address written on identification (e.g. passport, social security card)',
    EnglishAddressBusiness:
      'English address written on business entity documentation (e.g. certificate of incorporation, tax registration certificate)',
    PaymentInProgress: 'Payment in progress',
    AdditionalPaymentInProgress: 'Additional payment in progress',
    AdditionalPayment: 'Additional payment',
    Recovery: 'Recovery',

    WordTrademarkYouWish: 'Word trademark you wish to register',
    ImageOfYourStylized: 'Image of your stylized wordmark',
    ImageOfYourLogoMark: 'Image of your logo mark',
    ImageOfYourCompositeMark: 'Image of your composite mark',
    NeedHelpChoosingATrademarkType: 'Need help choosing a trademark type?',
    IfYouWishToFileMoreThan: 'If you wish to file more than one type, please submit multiple applications.',
    IfYouAreNotSureWhichTypeToChoose:
      'If you are not sure which type to choose, start with a word trademark as this offers the broadest level of protection.',
    Submitted: 'Your application has been submitted!',
    WeWillGetBack: 'We will get back to you within 24 business hours',
    AnotherApplication: 'Do you want to file another application?',
    FileANewApplication: 'File a new application',
    WhatAreTheNextSteps: 'What are the next steps?',
    YourPaymentIsConfirmedBy: 'Your payment is confirmed by Marq Vision.',
    YouSubmitInformationAnd: 'You submit information and documents requested by law firms.',
    WeWillNowStart: 'We will now start preparing your application',
    LawFirmsReviewAll: 'Law firms review all documents and file the application to each country’s IP office.',
    IpOfficesExamineTheApplication:
      'IP offices examine the application. If there are additional documents requested by IP offices, law firms prepare them upon your approval.',
    IpOfficesAnnounceFinalResults:
      'IP offices announce final results. You receive the registration certificate if your application is approved.',
    FileAnotherApplication: 'File another application',
    FileAnotherApplicationAndSaveNPercent: (n) => `File another application and SAVE ${n}%`,
    CheckYourApplicationStatus: 'Check your application status',
    ThankYouForYourPayment: 'Thank you for your payment!',
    ThankYouPayment: 'Thank you!',
    ThankYouPaymentDesc1: (onClick) => {
      return (
        <>
          You can continue working on your responses and documents&nbsp;
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onClick?.();
            }}
            style={{ textDecoration: 'none' }}
          >
            here
          </a>
          .
        </>
      );
    },
    ThankYouPaymentDesc2: 'Please provide required documents when you are ready.',
    ThankYouPaymentCompleted: "You're all set!",
    ThankYouPaymentCompletedDesc: 'Your submissions are in review',

    ThankYouPaymentDesc3: 'Your order has been placed successfully.',
    ThankYouPaymentDesc4: 'We will begin processing it right away.',
    YourTrademarkApplicationIsUnderPreparation:
      'Your trademark application is under preparation. We will get back to you soon with next steps.',
    PleaseCompleteYourPayment: 'Please complete the payment to continue with your trademark application',
    ThankYouForYourOrder: 'Thank you for your order!',
    DocumentsAndQuestionnaires: 'Documents & Questionnaire',
    DocumentsDescriptions1: 'Please provide the following materials when you are ready.',
    DocumentsDescriptions2: "We'll review your submissions and ready out to you in case we need anything else.",
    DocumentsProgressDone: (v, t) => `${v} / ${t} done`,
    DocumentsProgressAllSet: (v, t) => `${v} / ${t} done! You're all set.`,
    DocumentsPoa: (countryName) => `Power of Attorney - ${countryName}`,
    DocumentsPleaseSignThisForm: 'Please sign this form',
    DocumentsSubmitted: "I've submitted this document",
    DocumentsFullName: 'Full name',
    DocumentsFullNamePlaceholder: 'Enter full name',
    DocumentsPoaSignAgree: 'By clicking the button below, I certify I have read and agree to the document above',
    DocumentsPoaSign: 'Sign',
    DocumentsPoaSignedSuccessfully: 'Signed successfully',
    DocumentsRejectedDownloadLatest: 'Download your last submission',
    DocumentsUpload: 'Upload document',
    DocumentsSubmittedThisDoc: 'I’ve submitted this document',
    DocumentsEnterYourReplyHere: 'Enter your reply here',
    DocumentsSaving: 'saving...',
    DocumentsOther: 'Other',
    DocumentsPartneredWith: (partnerName) => `Partnered with ${partnerName}`,
    DocumentsNoPartnerInfo: 'Partner info not available',
    DocumentsStatusCompleted: 'Completed',
    DocumentsStatusReviewRequired: 'Review required',
    DocumentsViewForm: 'View form',
    DocumentsSubmitRequiredQnaDocs: 'Submit required questionnaire & documents',
    DocumentsReviewYourDocs: 'Please review your documents',
    ApplicationCollectingDocuments: 'Collecting Documents',
    DocumentsNoDocumentsRequested: 'No documents requested',
    DocumentsHasBeenSigned: 'This document has been signed successfully!',
    FinishedWarningPopupTitle: 'Are you sure you want to leave?',
    FinishedWarningPopupDest: 'Your application can be filed once we receive your response and all required documents',
    FinishedWarningPopupStay: 'Stay',
    FinishedWarningPopupContinue: "I'll do it later",
    Leave: 'Leave',

    LoginSuccessAndAutoSaved: 'Sign in successful! Your application will be auto-saved.',
    DoYouWantToLeave: 'Do you want to leave the application? Your details will be lost.',
    // MyApplication: 'My application',
    Applications: 'Applications',
    ApplicationId: 'Application ID',
    ApplicationCount: (count) => (
      <>
        <MDSTypography variant="T14" weight="medium">
          {count}
        </MDSTypography>
        <MDSTypography variant="T14">applications</MDSTypography>
      </>
    ),
    NoApplications: 'No applications',
    SubmittedDateNewest: 'Submitted Date (Newest)',
    SubmittedDateOldest: 'Submitted Date (Oldest)',
    UpdatedDateNewest: 'Updated Date (Newest)',
    UpdatedDateOldest: 'Updated Date (Oldest)',
    LastSavedDate: 'Last saved date',
    SubmittedDate: 'Submission',
    DateFormat: 'MMM DD, YYYY',
    DateFormatSlash: 'MM/DD/YYYY',
    SeeDetail: 'See details',
    Apply: 'Apply',
    ContractAndPayment: 'Contract & Payment',
    EligibilityCheck: 'Eligibility check',
    PaymentRequested: 'Payment requested',
    PaymentSuccess: 'Payment success',
    PaymentWaiting: 'Payment waiting',
    PaymentFailed: 'Payment failed',
    PaymentCanceled: 'Payment canceled',
    PaymentOverdue: 'Payment overdue',
    PaymentIncomplete: 'Payment incomplete',
    Preparation: 'Preparation',
    File: 'File',
    Examination: 'Examination',
    FinalDecision: 'Final Decision',
    Resume: 'Resume',
    FinalRejection: 'Final rejection',
    PublishForOppposition: 'Published for opposition',
    OppositionPending: 'Opposition pending',
    RegistrationGranted: 'Registration granted',
    RegistrationCompleted: 'Registration completed',
    Filed: 'Filed',
    UnderExamination: 'Under examination',
    PreliminarilyRejected: 'Preliminarily rejected',
    AmendmentSubmitted: 'Response/amendment submitted',
    AppealingRefusal: 'Appealing against final refusal',
    OvercomingMarks: 'Overcoming conflicting marks under examination',
    OvercameMarks: 'Successfully overcame conflicting marks',
    FailedMarks: 'Failed to overcome conflicting marks',
    // Apply: 'Apply',
    FilingPending: 'Filing pending',
    ConfirmingApplication: 'Confirming application',
    PreparingToFile: 'Preparing to file',
    StatusOfCountryUpdated: (countries: string, plural = false) =>
      `Status for ${Number(countries) ? `${countries} countries` : countries} ${plural ? 'have' : 'has'} been updated`,
    NewRequestFrom: (from: string, countries: string) =>
      `New request${from ? ` from ${from}` : ''}${countries ? ` about ${countries}` : ''}`,
    Select: 'Select',
    Enter: 'Enter',
    ApplicationStatus: 'Application status',
    Request: 'Request',
    invoice: 'Invoice',
    NoNewRequest: 'No new requests',
    DueDateClosest: 'Due date (closest)',
    CreatedDate: 'Created Date',
    AdditionalInformation: 'Additional information',
    TrademarkClasses: 'Trademark class(es)',
    ClassNumber: (number) => `Class ${number}`,
    TrademarkUsageHistory: 'Trademark usage history',
    AreYouSoldInUS: 'Are you currently using this trademark on any goods or services sold in the US?',
    WhenIsFirstInUs: 'When is the date of first commercial use in the US?',
    IDontKnow: 'I do not know',
    WhenIsDateOfFirst: 'When is the date of first use anywhere?',
    ReplyAndAttachFile: 'Reply & attach file',
    Reply: 'Reply',
    ChooseMultipleOption: 'Choose multiple options',
    ChooseAnOption: 'Choose an option',
    DueOn: (deadline, timezone) => `Due by ${deadline} ${timezone ? ` (${timezone} Time)` : ''}`,
    OverDue: (overdue: number) => `Overdue (${overdue} day)`,
    Send: 'Send',
    Sending: 'Sending',
    Other: 'Other',
    OtherDirect: 'Others (Direct input)',
    DateFormatWithTime: 'MMM DD, YYYY, HH:mm',
    YouCanOnlyAttachUpToNFiles: (max: number) => `You can only attach up to ${max} file${max > 1 ? 's' : ''}`,
    YouCanAttachFile: (max: number) => `You can attach up to ${max} file${max > 1 ? 's' : ''} (max. 20MB each)`,

    ApplicationHasBeenUpdated: 'The application has been edited.',
    LastEditedDate: 'Last edited date',
    Change: 'Change',
    Save: 'Save',
    Cancel: 'Cancel',
    Logout: 'Log out',
    Payment: 'Payment',
    SavedCreditOrDebitCards: 'Saved credit or debit cards',
    AddNewCreditOrDebitCard: 'Add new credit or debit card',
    EndingInN: (n: string) => `ending in ${n}`,
    AddNewCard: 'Add new card',
    PleaseEnterAValidCardNumber: 'Please enter a valid card number',
    PleaseEnterAValidExpiryDate: 'Please enter a valid expiry date',
    PleaseEnterAValidCVVNumber: 'Please enter a valid CVV number',
    HowToFindYourCVVCVCHTML:
      '<b>How to find your CVV/CVC</b><br /><br />Visa, Mastercard, Discover, and UnionPay display the three-digit CVV number on the back of the card, to the right of the signature.<br /><br />American Express displays the four-digit CVV number on the front of the card.',
    Delete: 'Delete',
    WordTrademark: 'Word trademark',
    LogoTrademark: 'Logo trademark',
    CompositeTrademark: 'Composite trademark',
    Consent: (evntTerms: () => void, eventPP: () => void) => (
      <>
        I agree and consent to the{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            evntTerms();
          }}
          style={{ color: MDSTheme.palette.blue[700] }}
        >
          Terms & Conditions
        </a>{' '}
        and the{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            eventPP();
          }}
          style={{ color: MDSTheme.palette.blue[700] }}
        >
          Privacy Policy
        </a>
        .
      </>
    ),
    EmailVerified: 'Email verified',
    PleaseCloseThisScreen: 'Please close this screen and go to the MARQ Folio to complete the verification.',
    Add: 'Add',
    CompletePayment: 'Complete Payment',
    TryAgain: 'Try Again',
    YourPaymentHasExpired: 'Your payment has expired. Please try again and make sure to complete payment by deadline.',
    CountriesAndClasses: 'Countries & Classes',
    OwnerAndInvoiceDetails: 'Owner & invoice details',
    BillingDetails: 'Billing Details',
    BillingDetailsMatch: 'Billing details match the owner’s details',
    PermanentResidence: 'Permanent residence',

    StreetAddress: 'Street address',
    City: 'City',
    ZipPostalCode: 'Zip/Postal code',
    PaymentMethod: 'Payment Method',
    SelectYourPreferredPaymentMethod: 'Select your preferred payment method',
    CreditOrDebitCard: 'Credit or debit card',
    BankTransfer: 'Bank transfer',
    Cardholder: 'Cardholder',
    CardNumber: 'Card number',
    ExpirationDate: 'Expiration date',
    CVVCVC: 'CVV / CVC',
    SaveCardForLaterUse: 'Save card for later use',
    PayN: (n: string) => `Pay${n ? ` ${n}` : ''}`,
    ByClickingTheXButtonJSX: (x: string, onTermsClick, onPrivacyClick) => (
      <>
        <div>{`By clicking the “${x}” button, you agree with the `}</div>
        <div>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onTermsClick();
            }}
            style={{ color: MDSTheme.palette.bluegray[800] }}
          >
            {`Terms and Conditions `}
          </a>
          <span>and</span>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onPrivacyClick();
            }}
            style={{ color: MDSTheme.palette.bluegray[800] }}
          >
            {` processing of personal data.`}
          </a>
        </div>
      </>
    ),
    NewCreditOrDebitCard: 'New credit or debit card',
    Summary: 'Summary',
    AbovePriceIsValidUntil: (d: string) => `Pricing quote is valid until ${d}`,
    PlaceAnOrder: 'Place an order',
    Order: 'Order',
    AccountHolder: 'Account holder',
    AccountNumber: 'Account number',
    AccountID: 'Account ID',
    RoutingNumber: 'Routing number',
    SwiftCode: 'SWIFT',
    BankName: 'Bank name',
    BankAddress: 'Bank address',
    Copy: 'Copy',
    CopiedToClipboard: 'Copied to clipboard',
    ReferenceNumber: 'Reference number',
    DueDate: 'Due date',
    DownloadInvoice: 'Download Invoice',
    YourTrademark: 'Your Trademark',
    TypeOfTrademark: 'Type of trademark',
    ShowDetails: 'Show details',
    HideDetails: 'Hide details',
    Countries: 'Countries',
    Classes: 'Classes',
    Class: 'Class',

    SendReport: 'Eligibility Report',
    Contract: 'Invoice',
    FilingSendReport: 'Filing Guide',
    FileDoneReport: 'Filed Application',
    OaReport: 'OA Report',
    OaCaNoti: 'Filed Response',
    OppReport: 'Notice of Publication',
    OppReqInfo: 'Opposition Report',
    OppReqDone: 'Filed Response',
    OppResultReport: 'Result',
    AppReport: 'Filed Application',
    AppLose: 'Result',
    AppWin: 'Result',
    RejectReport: 'Result & Next Steps',
    RegReport: 'Acceptance Notice',
    RegDoneReport: 'Invoice',
    RegElecReport: 'E-Certificate',
    CertSend: 'Certificate',
    CertAnnDone: 'Certificate & Registration Notice',
    RetrievalInfo: 'Application Draft',
    RetrievalDone: 'Filed Application',
    RetrievalReqReceive: 'Response',
    RetrievalReqDone: 'Response',
    RetrievalWin: 'Result',
    RetrievalLose: 'Result',

    ConfirmedPrice: 'Confirmed Price',
    DragAndDropFiles: 'Drag and drop or browse files',
    Max20mb: '(max. 20MB)',
    ClickHereToBrowse: 'Click here to browse',

    PaymentInvalidConflict: 'Invalidation of conflicting mark',
    Watch: 'Watch',
    WatchStartDate: 'Watch start date',
    GetStartedByAdding: 'Get started by adding your trademark to watch',
    BeAlertedWhenAThirdPartyTries:
      "Be alerted when a third party tries to file marks that are identical to or similar to your brand's mark",
    AddNewTrademarkToWatch: 'Add new trademark to watch',
    Table: 'Table',
    TrademarkOverview: 'Trademark overview',
    TmOverView: 'TM overview',
    NewTrademark: 'New trademark',
    WatchCount: (count: number) => (
      <>
        <span>{count}</span> Watch
      </>
    ),
    NewTrademarkWatch: 'New trademark watch',
    EnterTrademarkName: 'Enter trademark name',
    TrademarkName: 'Trademark name',
    TrademarkImage: 'Trademark image (logo)',
    CountryToWatch: 'Country to watch',
    SelectCountry: 'Select country(s)',
    SelectWatchStartDate: 'Select watch start date',
    WatchPeriod: 'Watch period',
    SelectPeriod: 'Select period',
    ByCheckingTheBox:
      'By checking the box, I consent to applying for the trademark watch service and the collection of personal information for this purpose.',
    AddTrademarkToWatch: 'Add new trademark to watch',
    DragAndDropOrBrowse: 'Drag and drop or Browse',
    Period: 'Period',
    Status: 'Status',
    StatusDetails: 'Status details',
    YourRequestIsBeing: 'Your request is being reviewed. We will get back to you shortly.',
    EverythingLooksGreat: 'Everything looks great!',
    TakeAction: 'Take action',
    RemindMeLater: 'Remind me later',
    WatchStartDateDesc: 'Watch start date (Newest)',
    WatchStartDateAsc: 'Watch start date (Oldest)',
    UrgencyDesc: 'Status (Highest Urgency)',
    OneMonths: '1 month',
    SixMonths: '6 months',
    OneYear: '1 year',
    ThreeYear: '3 years',
    WatchCancel: 'Cancel',
    logo: 'Logo',
    word: 'Word',
    composite: 'Composite',
    designRight: 'Design right',
    ExpectedCompletion: 'Expected Completion',
    ExpectedCompletionDescription: 'This is an estimated registration date and may change as the case progresses',

    LogoMark: 'Logo mark',

    FilingApplication: 'Filing application',
    ApplicationInReview: 'Application in review',
    AwaitingTrademark: 'Awaiting trademark',
    TrademarkRegistered: 'Trademark registered',
    RequestInProgress: 'Request in progress',
    EvaluationInProgress: 'Evaluation in progress',
    WaitingForPayment: 'Waiting for payment',
    PreparingApplication: 'Preparing application',
    ApplicationDrafted: 'Application drafted',
    ApplicationDraftConfirmed: 'Application draft confirmed',
    ApplicationFiled: 'Application filed',
    PreliminarilyRefused: 'Preliminarily refused',
    DefendingRefusal: 'Defending refusal',
    PublishedForOpposition: 'Published for opposition',
    ApplicationOpposed: 'Application opposed',
    AppealingAgainstRejection: 'Appealing against rejection',
    RetrievingConflictingMarks: 'Retrieving conflicting marks',
    RetrievingTradeMarks: 'Retrieving trademarks',
    ConflictingMarksRetrieved: 'Conflicting marks retrieved',
    RetrievalFailed: 'Retrieval failed',
    WaitingForAdditionalPayment: 'Waiting for additional payment',
    AdditionalPaymentFailed: 'Additional payment failed',
    AdditionalPaymentCanceled: 'Additional payment canceled',
    ApplicationRejected: 'Application rejected',

    TrademarkApplication: 'Trademark application',
    ReadMore: 'Read more',
    ShowLess: 'Show less',
    ContinueToBillingDetails: 'Continue to billing details',
    SignAndContinue: 'Sign & Continue to payment',
    SaveAndContinue: 'Save & Continue',
    Edit: 'Edit',

    OrderForm: 'Order form',
    OrderFormDesc: 'Please read and sign this form',
    ConfirmFullName: 'Confirm your full name',
    ConfirmLegalName: 'Confirm your full legal name',
    OrderFormSign: (onClickTerms, onClickPP) => (
      <>
        By clicking Sign, I (1) agree that the above Full Name will be the electronic representation of my signature for
        all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as
        a pen-and-paper signature or initial, and (2) agree with the{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClickTerms();
          }}
        >
          Terms and Conditions
        </a>{' '}
        and{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClickPP();
          }}
        >
          processing of personal data
        </a>
        .
      </>
    ),
    DoYouWantToLeavePayment: 'Do you want to leave the page? Your details will be lost.',

    PleaseSignIn: 'Please sign in',
    ToContinueTo: (pageName) => `to continue to ${pageName}`,
    ThisPage: 'this page',

    OppInfo: 'Opposition information',
    OppReq: 'Opposition request',
    OppDone: 'Opposition done',
    OppResp: 'Opposition received',
    OppRedo: 'Opposition re-request',
    OppRedoDone: 'Opposition re-request completed',
    ResultReceive: 'Results received',
  },

  [LanguageEnum.Korean]: {
    NeedWorldwideTrademarkFiling: '해외 상표 출원이 필요하신가요?',
    ARevolutionaryWayToRegisterTrademarks: '클릭 몇 번으로 전세계에<br />간편하게 출원해보세요',
    GuaranteedRegistrationIsOneClickAway: '지금 신청하고<br/>100% 환불 보장 받으세요',
    ApplyNow: '지금 신청하기',
    ProtectYourTrademark: '추가 비용 없이 투명한 가격으로 전세계 상표 등록을 도와드립니다',
    ProtectYourTrademark2: '전 세계에 상표 등록을 도와드립니다.',
    NoHiddenFees: '추가 비용 없이 투명한 가격으로!',
    GetYourTrademarkNow: '지금 상표 출원하기',
    WhyFileTrademarkAbroad: '왜 해외 상표 출원을<br/>해야 할까요?',
    WhyFileTrademarkAbroadDescription:
      "글로벌 시장으로의 진출은 나날이 쉽고 중요해지고 있습니다. 이제 해외 상표 출원은 해당 국가에서 매출과 브랜드 가치를 지키기 위해 필수적인 단계가 되었습니다. <br /><br />국내에 상표를 등록해도, 해외에서는 해당 상표가 보호되지 않습니다. 대부분의 국가는 선출원주의를 따르기 때문에 먼저 상표를 출원한 누군가가 ‘합법적으로' 상표를 빼앗을 수도 있습니다.<br /><br />상표를 빼앗기면 매출 손실이 발생할 뿐 아니라, 브랜드 가치도 크게 훼손될 수 있습니다. 이러한 피해가 발생하기 전에, 진출 가능성이 있는 국가에 미리 상표를 등록해두는 것이 중요합니다.",
    YourBrandsTrademarkBecomes:
      '상표는 치열한 경쟁 속에서 브랜드를 지키기 위한 가장 강력한 무기이며, 힘들게 쌓아 올린 브랜드 가치를 지키는 수단입니다.',
    WhatAreTheChallengesOfFilingAbroad: '해외 상표 출원,<br />왜 어려울까요?',
    WhenItComesToRegisteringYourTrademarksAbroad:
      '길고 복잡한 해외 상표 출원 프로세스는 시작하기도 전부터 벅차게만 느껴집니다.<br/><br/>모든 국가에서 일일이 신뢰할만한 현지 로펌을 찾는 건 큰 시간이 소요되고, 한 번에 처리하려면 그만큼 수수료를 추가로 지불해야 하죠.<br/><br/>보다 효율적으로 전세계에 상표를 출원할 수는 없을까요?',
    ExperienceTheIndustry: '업계 최고 효율로 상표 출원을 도와드립니다',
    WeOnlyPartnerWithTopTierLawFirmsInEachCountry:
      '마크폴리오는 국가별 탑티어 로펌들과만 협업하며, 현지 최고의 서비스를 제공합니다.<br/><br/>간단한 온라인 신청서를 제출하고, 대시보드에서 손쉽게 출원 상태를 확인해보세요. 더이상 진행 상황 확인을 위해 매번 전화하거나 이메일을 보내지 않아도 됩니다.',
    HowDoesItWork: '어떻게 진행되나요?',
    SubmitYourApplication: '신청서 제출',
    SubmittingAnApplicationOnlyTakes:
      '단 몇 번의 클릭으로 간편하게 신청서를 제출하세요. 24시간 내 견적을 전달드립니다.',
    LocalLawFirmAssessment: '로펌 진단',
    OurPartnerLawFirmWillReview: '파트너 로펌에서 신청서를 리뷰한 후 출원 전략을 전달드릴 예정입니다.',
    UploadDocuments: '서류 전달',
    ThroughTheMyApplicationDashboard:
      '마크폴리오 대시보드에서 언제든 출원 현황을 확인하고, 필요한 서류를 로펌에 전달하실 수 있습니다.',
    ExaminationByTheTrademarkOffice: '특허청 검사',
    OnAverageFilingToFinalApprovalTakes:
      '특허청 심사를 거쳐 최종 등록이 결정됩니다. 일반적으로 6~12개월의 기간이 소요됩니다.',
    DoneExclamation: '완료!',
    OnceEverythingIsCompletedAnd: '등록이 완료되면 마크폴리오에서 등록증을 확인합니다. 상표 보호가 시작됩니다.',
    SeeYourInitialQuoteBeforeYouFile: '신청서 작성 전 최초 견적을 확인해 보세요',
    FreeNoObligationNoCommitment: '조건 · 계약 없이 무료로 견적 확인',
    WhyMarqFolio: '왜 마크폴리오에서<br/>출원해야 할까요?',
    AreYourTMsAtRiskInChina: '중국에 상표를<br />뺏기셨나요?',
    GlobalNetworkOfLeadingPartners: '글로벌 탑티어 로펌<br />네트워크 보유',
    WeOnlyPartnerWithTopTierLawFirms:
      '마크폴리오는 국가별 최상위 로펌과 협업하며, 합리적인 가격으로 최고의 서비스를 제공합니다.',
    GuaranteedRegistration: '100% 환불 보장',
    TrademarkRejectionRatesCanBeAsHighAs:
      '상표는 최대 75% 확률로 거절되며, 거절을 극복하기 위해서는 수많은 시간과 비용이 추가로 소요됩니다. 마크폴리오는 철저한 사전조사를 통해 거절 가능성을 최소화하고, 최종 결과가 나올 때까지 추가 비용 없이 모든 서포트를 제공하며 최종 거절될 경우 비용을 전액 환불드립니다. ',
    NoAdditionalCosts: '숨겨진 비용 0원',
    BrandsAreOftenChargedAdditionalHourlyRates:
      '출원 건에 중간 보완이 필요하거나 등록이 성사되면, 그 대가로 추가 비용이 발생하는 경우가 많습니다. 시간 단위로 청구되는 비용 때문에 최종 가격은 예측할 수 없이 비싸지기도 합니다. 마크폴리오는 견적서 외 숨은 비용을 일체 추가하지 않고, 합리적이고 투명한 가격으로 서비스를 제공합니다.',
    RealtimeStatusTracking: '실시간 출원 현황 확인',
    TheMARQFolioDashboardAllows:
      '마크폴리오에서는 웹사이트 대시보드를 통해 출원 진행 상황을 실시간으로 상세하게 확인하실 수 있습니다.',
    WhatsInclude: '가격에는 어떤 항목이<br/>포함되어 있나요?',
    Pricing: '상품',
    KeyFeatures: '주요 항목',
    TrademarkEligibilityCheck: '상표 적격성 검토',
    ConsultationWithLeadingLawFirms: '탑티어 로펌의 출원 전략 컨설팅',
    ApplicationPreparationAndFiling: '출원 서류 준비 및 제출',
    GovernmentFeesForApplication: '출원 관련 특허청 관납료',
    RealtimeApplicationProgressUpdate: '실시간 진행상황 업데이트',
    GovernmentAndServiceFeesForRegistration: '등록 관련 특허청 관납료 및 서비스 수수료',
    GovernmentAndServiceFeesInCaseOfPreliminaryRejections: '중간 사건 관련 특허청 관납료 및 서비스 수수료',
    UnlimitedRejectionSupport: '중간 사건 무한 대응',
    MoneyBackGuarantee: '최종 거절 시 100% 환불',
    TenYearTrademarkValidity: '유효기간 10년의 상표 등록증',
    OurStory: '마크비전 소개',
    MarqVisionHelpsGlobalBrands:
      '마크비전은 AI를 통해 모든 창작과 혁신을 보호하는 사명 아래 브랜드가 지식재산권(IP)을 생성, 관리, 보호 및 수익화할 수 있도록 지원합니다. 빠르게 커지는 글로벌 위조상품 시장에서 브랜드를 보호하기 위해 전세계 1,500개 이상의 마켓플레이스 및 소셜미디어에서 위조상품과 불법콘텐츠를 탐지하고 보호하고 있습니다. 대부분의 브랜드들이 반복적인 수동 작업을 통해 진행하던 IP 보호 업무를 이미지 인식 및 자연어 처리 기술 기반으로 자동화하여, 누구보다 빠르고 정확하게 위조상품과 불법콘텐츠를 제거하고 있습니다.<br /><br />마크비전은 2020년 하버드 로스쿨에서 탄생해 DST 글로벌, 소프트뱅크벤처스, 에이티넘인베스트먼트, 와이콤비네이터(YC) 등으로부터 투자를 유치했습니다. 루이비통모에헤네시(LVMH)가 주최하는 2022 LVMH 이노베이션 어워드에서 최종 우승을 차지하였습니다.',
    LearnMore: '더보기: ',
    EnjoyMoreTransparency: '투명한 가격 및 진행상황',
    OurDashboardProvidesYouWith:
      '하나의 대시보드에서 모든 출원서에 대한 진행상황을 실시간으로 확인하고 관리할 수 있습니다.',
    GetYourTrademarkFaster: '빠른 상표 등록',
    OurRevolutionaryOnlineProcess:
      '혁신적인 온라인 프로세스로 커뮤니케이션 시간과 비용을 최소화하여 더욱 빠르게 상표를 출원할 수 있습니다.',
    WorkWithTheBestLocalLawFirms: '국가별 탑티어 로펌 네트워크',
    OurEliteGlobalNetworkOfTopTierLawFirms:
      '현지 탑티어 로펌으로 구성된 마크폴리오를 통해 안전하게 상표를 출원할 수 있습니다.',
    SaveTimeWithASimpleOnlineProcess: '간편한 온라인 프로세스',
    SubmittingAnApplicationOnlyTakesAFewMinutes:
      '마크폴리오의 직관적인 대시보드를 통해 단 몇 분만에 신청서를 제출하고, 어려운 출원 프로세스를 쉽게 이해할 수 있습니다.',

    GovernmentFee: '관납료',
    ServiceFee: '서비스비',
    ProtectionPlan: '환불 보장 플랜',

    AreYourTrademarksAtRiskInChina: '중국에 상표를 뺏기셨나요?',
    DontLoseYourTrademarksToSquatters: '상표 선점은 누구한테든 일어날 수 있습니다',
    NineDotThreeMillion: '930만 개',
    TrademarksRegisteredInChinaIn2020: '2020년 기준, 중국에만 총 930만 개의 상표가 등록되었습니다',
    ThreeMonths: '3개월',
    YouOnlyHaveThreeMonthsHTML: '뺏긴 상표에 대한 이의제기는 <b>3개월 이내</b>에 이루어져야 합니다',
    FiveYears: '5년',
    YouMustFileAnInvalidationHTML: '뺏긴 상표에 대한 무효심판은 <b>5년 내</b>에만 청구할 수 있습니다',
    FifteenHundredThousand: '$150,000',
    TakingBackYourLostTrademark: '뺏긴 상표를 되찾는 데 <b>평균 $150,000</b>의 비용이 들며 최소 1년이 소요됩니다',
    TakeControlOfYourTrademarksInChina: '중국 상표, 놓치지 마세요',
    AutomaticallyReceiveANotification: '중국에서 상표 선점 위험을 자동으로 감지해 알림을 보내드립니다',
    SignUpNow: '상표 모니터링 신청하기',
    HasYourTrademarkAlreadyBeenRegisteredInChina: '이미 상표를 뺏기셨나요?',
    WeCanHelp: '상표 선점 관련 경험이 풍부한 마크폴리오의 파트너 로펌들이 도와드리겠습니다',
    GetYourTrademarksBackNow: '지금 상표 되찾기',
    NPercentDiscountWillBeApplied: (n: number) => `결제 시 ${n}% 할인 자동 적용`,
    FileAnApplication: '신청서 작성',
    MyApplication: '내 신청내역',
    IpManagement: '상표권 관리',
    Profile: '내 정보',
    Login: '로그인',
    DoYouHaveAccount: 'MARQ Folio 회원이신가요?',
    Yes: '네',
    No: '아니오',
    IHaveMarqCommerceAccount: '마크커머스/마크콘텐츠 계정이 있습니다',
    YouMustCreateSeperateAccount: '마크커머스/마크콘텐츠 계정이 이미 있더라도, 마크폴리오에 새로 가입해주셔야 합니다',
    IAlreadySignedUp: '이미 계정이 있습니까? 로그인하기',
    INeverSignedUp: '아직 계정이 없습니다',
    EmailAddress: '이메일 주소',
    Password: '비밀번호',
    CantFindAccount: '존재하지 않는 이메일 계정입니다. 다시 시도해주세요.',
    IncorrectPassword: '비밀번호가 일치하지 않습니다. 다시 시도해주세요.',
    ForgotPassword: '비밀번호를 잊으셨나요?',
    LoginSuccessful: '로그인에 성공했습니다!',
    SignUpSuccessful: '가입이 완료되었습니다!',
    VerifyEmailSending: '인증 메일 전송중',
    VerifyEmailSent: '인증 메일 발송됨.',
    VerifyEmail: '이메일 인증하기',
    EnterValidEmail: '유효한 이메일 주소를 입력해주세요',
    SendAgainAfterNSeconds: (timer) => `${timer}초 후 다시 시도.`,
    ResendVerifyEmail: '인증 메일 재발송',
    ToConfirmYour: '이메일로 발송된 URL에 접속한 후 인증 완료하기를 클릭해주세요',
    GoToYourEmail: '',
    ReturnToThisScreen: '',
    CompleteVerification: '인증 완료',
    Checking: '확인중',
    VerificationIncomplete: '인증이 완료되지 않았습니다. 받은메일함 혹은 이메일주소를 확인해주세요.',
    Verified: '인증되었습니다!',
    MoreThan8Char: '8자 이상',
    IncludeAtLeast1Letter: '영문, 특수문자, 숫자를 모두 1자 이상 포함해주세요',
    PasswordConfirmation: '비밀번호 확인',
    Confirmed: '확인되었습니다',
    ResetPasswordAndLoggingIn: '비밀번호 변경 및 로그인중',
    ResetPasswordAndLogin: '비밀번호 변경 및 로그인',
    SigningUp: '가입중',
    SignUp: '계정 생성하기',
    LoggingIn: '로그인중',
    EmailDoesNotExist: '존재하지 않는 이메일 계정입니다. 다시 시도해 보거나 가입해주세요.',
    EmailAlreadyRegistered: '이미 가입된 이메일 입니다. 로그인 해주세요.',
    ReferralCode: '추천 코드 (선택)',
    SignInToYourAccount: '로그인',
    NewToMARQFolio: '마크폴리오 계정이 없으신가요?',
    CreateAnAccount: '계정 생성하기',
    Prev: '이전',
    SaveTemporarily: '임시저장',
    AutoSaved: '자동저장됨',
    Submit: '제출',
    Next: '다음',
    Continue: '계속',
    NotVerified: '아직 인증되지 않았습니다.',

    SelectCountries: '어떤 국가에 상표를 등록하고 싶으신가요?',
    WhereDoYouWishToFileYourTrademark: '어떤 국가에 상표를 출원하고 싶으신가요?',
    NCountriesSelected: (countries) => `${countries}개 국가 선택됨`,
    FrequentlySelected: '주요 선택 국가',
    Search: '검색',
    CantFindWhat: '원하는 국가를 찾으실 수 없나요?',
    LookingForATrademark: '찾으시는 국가가 리스트에 없나요?',
    PleaseListOut: '아래에 희망하는 국가명을 입력해주세요. 빠르게 검토 후 안내 드리겠습니다.',
    EnterTheCountry: '등록 희망하는 국가명을 입력해주세요. 빠르게 검토 후 안내 드리겠습니다.',
    Country123: '국가 1, 국가 2, 국가 3',
    AddCountries: '국가 추가',
    SelectType: '어떤 유형의 상표를 출원하고 싶으신가요?',
    TrademarkTips: '상표 선정 팁',
    ChooseAgain: '다시 선택',
    Word: '문자',
    EnterTheWord: '출원하려는 문자를 입력해주세요',
    UploadYourLogo: '도형 상표 이미지를 첨부해주세요',
    UploadYourComposite: '복합 상표 이미지를 첨부해 주세요',
    WordTrademarkTips: '문자 상표 팁',
    MakeUpYourOwn: '고유한 상호를 선택해보세요 (예: 마이크로소프트)',
    AvoidGeneric: '지나치게 포괄적이거나 단순 설명적인 명칭은 피해주세요 (예: 맛있는 BBQ, 얼린 요거트)',
    IfYouWishToFileInChina: '중국에 출원을 희망하실 경우 특정 지역명을 포함하지 말아주세요 (예: 보스턴 차우더)',
    LogoTrademarkTips: '도형 상표 팁',
    ChooseALogoMark: '이미 출원 혹은 등록된 상표와 비슷한 로고를 고르지 않도록 유의해주세요 ',
    CompositeTrademarkTips: '복합 상표 팁',
    ItIsRecommendToRegister:
      '완전한 보호를 원하실 경우 문자 상표와 도형 상표를 각각 따로 출원하는 것을 추천드립니다. 복합 상표로 등록한 뒤 상표 디자인이 바뀌게 되면 (예: 로고 위치가 브랜드명 위에서 옆으로 옮겨짐) 새로운 상표 출원이 필요해질 수 있습니다.',
    EnterTheWordElement: '상표의 문자 부분을 입력해주세요',
    Logo: '도형',
    Composite: '복합',
    ProvidesTheBroadestLevelOfProtection:
      '스타일, 디자인, 폰트, 색상과 관계 없이 가장 넓게 브랜드명을 보호 받을 수 있습니다',
    ProvidesProtectionForYourBrand:
      '브랜드를 나타내는 디자인 및 시각적 요소를 어떤 색상으로든 (텍스트 없이) 보호 받을 수 있습니다',
    ProvidesProtectionForBoth: '시각적 요소와 디자인된 브랜드 이름을 한 번에 보호 받을 수 있습니다',
    PleaseEnterWordToRegister: '상표에 사용되는 문자를 입력해주세요',
    IsStylized: '디자인된 문자인가요?',
    StylizedWord: '디자인된 문자',
    UnstylizedWord: '디자인되지 않은 문자',
    PleaseUploadWordmark: '디자인된 문자 상표 이미지를 첨부해주세요',
    PleaseUploadLogo: '상표 이미지를 첨부해주세요',
    PleaseEnterPortion: '상표에 사용되는 문자를 입력해주세요',
    PleaseUploadCompositeMark: '상표 이미지를 첨부해주세요',
    ReUploadImage: '다른 이미지 첨부',
    UploadImage: '이미지 첨부',
    ImageSupport: '이미지 파일(JPG, HEIC, GIF, PNG)만 첨부할 수 있습니다. 최대 용량은 20MB입니다.',
    FileIsLarge: '파일 크기는 20MB를 넘지 않아야 합니다.',
    AllowFileType: '이미지와 PDF 파일(JPG, JPEG, HEIC, GIF, PNG, PDF)만 첨부할 수  있습니다.',
    TheReason: '상표 등록은 경쟁사와 귀사의 구분을 위해 필요합니다.',
    PossibleRejectionCases: '거절될 가능성이 있는 상표 예시',
    IndistinctiveTrademark: '식별력이 부족한 상표',
    PureDescriptiveTrademark: '단순 설명형 상표',
    Copycat: '모방 상표',
    WhatGoodsOrServiceUse: '이 상표를 통해 어떤 제품 및 서비스를 제공하고 계신가요 (혹은 제공하실 예정인가요)?',
    SearchByKeywordsOrClassNumber: '키워드 혹은 상품분류코드로 검색해보세요',
    BreadCosmeticsClass: '빵, 화장품, 제1류, 제43류',
    PleaseListOnlyUsingProducts: '현재 사용 중이거나, 실제 사용 계획이 있는 제품 및 서비스만 입력해주세요',
    UpTo200Char: '최대 200자까지 입력할 수 있습니다',
    NSelected: (n: number) => `${n} 선택됨`,
    SelectAll: '전체 선택',
    Clear: '전체 해제',
    SelectClasses: '상품 분류 선택',
    PleaseShareWebsiteOrMaterials: '이 제품 및 서비스를 소개하는 웹사이트 링크나 자료를 첨부해주세요',
    Optional: '선택 항목',
    OR: '또는',
    UploadFile: '파일 첨부',
    UpTo6Files: '최대 6개 첨부 가능',
    EnterUrl: 'URL 입력',
    AddMoreUrl: 'URL 추가',
    ShareAnyInformation: '상품 및 서비스를 소개하는 자료를 첨부해주세요',
    YouCanAddUpToSixHTML:
      '회사 소개용 PPT, 회사 웹사이트나 소셜미디어, Amazon 스토어 주소 등을<br />최대 6개까지 첨부하실 수 있습니다',
    OwnerType: '권리자 유형',
    Individual: '개인',
    Company: '법인',
    LegalNameOfIndividualOwner: '상표권자 이름',
    LastName: '성',
    FirstName: '이름',
    Nationality: '국적',
    Country: '국가',
    CompanyName: '법인명',
    CountryCorporated: '소속 국가',
    PhoneNumber: '연락처',
    CountryNumber: '국가 번호',
    ApplicationDetails: '신청서 상세',
    ApplicantDetails: '신청자 정보',
    CountryOfApplication: '신청 국가',
    TrademarkType: '상표 유형',
    TrademarkDescription: '상표 설명',
    ReferencesOfTrademarkUsages: '상표 사용 자료',
    ReferencesOfYourTrademarkUsedInGoodsOrServices: '상품 및 서비스를 소개하는 웹사이트 링크나 자료',
    PleaseProvideReferences: '이 상품 및 서비스를 소개하는 웹사이트 링크나 자료를 첨부해주세요',
    UpdateMyInfo: '계정정보를 위 내용으로 업데이트합니다',
    EstimatedPrice: '예상 견적',
    TotalPrice: '총 견적',
    PriceEstimationIs: '해당 국가는 현재 견적 제공이 어렵습니다. 빠르게 가능 여부 확인해 답변 드릴게요.',
    AddMoreCountries: '국가 추가',
    AddNMoreCountries: (n: number, p: number) => `국가 ${n}개 추가하고 ${p}% 할인 받으세요`,
    NPercentsMultiCountryDiscount: (n: number) => `${n}% 멀티 국가 할인`,
    NPercentsSecondAppDiscount: (n: number) => `두 번째 상표 할인 ${n}%`,
    NPercentsAdditionalDiscount: (n: number) => `추가 할인 ${n}%`,
    NClasses: (n: number) => (
      <>
        <span>{n}</span>개 상품분류
      </>
    ),
    FirstClass: '첫 상품분류',
    EachAdditionalClass: '상품분류 추가',
    NAdditionalClasses: (n: number) => `추가 상품분류 ${n}개`,
    IncludeOneClass: (n: number) => `1개 류 가격입니다. 상품 류가 추가될 때마다 $${n}가 추가됩니다.`,
    OtherCountriesYouWishToRegister: '등록을 희망하는 기타 국가',
    GoodsAndServices: '상품 및 서비스',
    GoodsAndServicesYouOffer: '상표를 이용해 제공할 상품 혹은 서비스',
    SelectByCountry: '국가별 설정',
    AddMoreClasses: '상품분류 추가',
    EditClass: '상품분류 수정', // TBC
    Trademark: '상표', // TBC
    WhoIsTheIntended: '상표권자는 누구인가요?',
    ViewEstimatedPrice: '예상 견적 보기',
    Documents: '서류',

    DescriptionOfYourTrademark: '상표 설명',
    TypeOfYourTrademark: '상표 유형',
    SorryWeCannotProcess: '죄송합니다. 지금은 결제를 진행하실 수 없습니다.',
    AreYouSureWantToDelete: '신청서를 삭제하시겠습니까?',
    ResumeApplication: '신청서 작성',

    ContactDetails: '개인 연락처 정보',
    EnglishName: '여권 및 주민등록증상 영문 성명',
    EnglishNameBusiness: '사업자등록증 및 법인등기부등록상 영문 사업장 소재지',
    LegalNameOfCompany: '법인명',
    Address: '주소',
    ChineseAddress: '한자 주소지 정보',
    WriteItMyself: '직접 기재',
    RequestTranslation: '번역 요청',
    OurPartnerLawFirmWillTranslate: '현지 로펌에서 상기 영문 주소를 번역하여 출원서에 기재하게 됩니다',
    IConsentUsingTranslated: '번역된 주소를 사용하는 데 동의합니다',
    EnglishAddress: '주민등록증상 주소의 영문 버전',
    EnglishAddressBusiness: '사업자등록증 및 법인등기부등록상 영문 사업장 소재지',
    PaymentInProgress: '결제 진행중',
    AdditionalPaymentInProgress: '추가 결제 진행중',
    AdditionalPayment: '추가 결제',
    Recovery: '선행상표대응',

    WordTrademarkYouWish: '문자 상표',
    ImageOfYourStylized: '디자인된 문자 상표 이미지',
    ImageOfYourLogoMark: '도형 상표 이미지',
    ImageOfYourCompositeMark: '복합 상표 이미지',
    NeedHelpChoosingATrademarkType: '상표 유형 선택에 도움이 필요하신가요?',
    IfYouWishToFileMoreThan: '두 개 이상의 유형을 출원하고 싶으시다면 신청서를 나누어 제출해주세요.',
    IfYouAreNotSureWhichTypeToChoose:
      '어떤 유형을 선택해야 할지 모르겠다면, 가장 넓은 범위의 보호를 제공하는 문자 상표로 시작해보세요.',
    Submitted: '신청서가 제출되었습니다!',
    WeWillGetBack: '영업시간 기준 24시간 내 연락 드리겠습니다',
    AnotherApplication: '다른 신청서를 작성하시겠어요?',
    FileANewApplication: '새 신청서 작성하기',
    WhatAreTheNextSteps: '다음 절차는 어떻게 되나요?',
    YourPaymentIsConfirmedBy: '최종 견적에 대한 결제를 진행합니다.',
    YouSubmitInformationAnd: '각국 출원에 필요한 정보 및 서류를 취합합니다.',
    WeWillNowStart: '출원서 준비를 시작합니다.',
    LawFirmsReviewAll: '로펌에서 출원서를 확정하여 각국 특허청에 제출합니다.',
    IpOfficesExamineTheApplication:
      '특허청에서 출원서를 심사합니다. 추가 요청 서류가 있을 경우 로펌에서 귀사와 확정해 서류를 보완합니다.',
    IpOfficesAnnounceFinalResults: '특허청에서 최종 결과를 발표합니다. 등록이 승인되면 상표 등록증을 받게 됩니다.',
    FileAnotherApplication: '추가 상표 신청',
    FileAnotherApplicationAndSaveNPercent: (n) => `추가 상표 신청하고 ${n}% 할인 받기`,
    CheckYourApplicationStatus: '출원 현황 확인',
    ThankYouForYourPayment: '결제가 완료되었습니다!',
    ThankYouPayment: 'Thank you!',
    ThankYouPaymentDesc1: (onClick) => {
      return (
        <>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onClick?.();
            }}
          >
            여기
          </a>
          서 서류 제출을 마무리하실 수 있습니다.
        </>
      );
    },
    ThankYouPaymentDesc2: '가능한 빨리 서류를 제출해주세요.',
    ThankYouPaymentCompleted: '모두 제출되었습니다!',
    ThankYouPaymentCompletedDesc: '제출하신 서류를 검토하고 있습니다',
    ThankYouPaymentDesc3: 'Your order has been placed successfully.',
    ThankYouPaymentDesc4: 'We will begin processing it right away.',

    YourTrademarkApplicationIsUnderPreparation:
      '상표 출원서를 준비하고 있습니다. 다음 절차에 대해 빠르게 안내드리겠습니다.',
    PleaseCompleteYourPayment: '결제를 진행해주세요. 결제가 완료되면 출원서 준비가 시작됩니다.',
    ThankYouForYourOrder: '주문이 완료되었습니다!',
    DocumentsAndQuestionnaires: '서류 및 질문',
    DocumentsDescriptions1: '아래 리스트의 서류들을 제출해주세요.',
    DocumentsDescriptions2: '검토 후 보완이 필요한 사항이 있으면 연락드리겠습니다.',
    DocumentsProgressDone: (v, t) => `${v} / ${t} 완료`,
    DocumentsProgressAllSet: (v, t) => `${v} / ${t} 완료! 모두 제출되었습니다.`,
    DocumentsPoa: (countryName) => `위임장 - ${countryName}`,
    DocumentsPleaseSignThisForm: '아래 양식에 서명해주세요',
    DocumentsSubmitted: '서류 제출을 완료했습니다',
    DocumentsFullName: '성명',
    DocumentsFullNamePlaceholder: '성명을 입력해주세요',
    DocumentsPoaSignAgree: '아래의 버튼을 클릭함으로써 이용약관 및 개인정보처리방침에 동의합니다',
    DocumentsPoaSign: '서명',
    DocumentsPoaSignedSuccessfully: '서명 완료',
    DocumentsRejectedDownloadLatest: '지난 제출 서류 다운로드',
    DocumentsUpload: '문서 업로드',
    DocumentsSubmittedThisDoc: '서류 제출을 완료했습니다',
    DocumentsEnterYourReplyHere: 'Enter your reply here',
    DocumentsSaving: '저장 중...',
    DocumentsOther: '기타',
    DocumentsPartneredWith: (partnerName) => `파트너 로펌: ${partnerName}`,
    DocumentsNoPartnerInfo: '파트너 로펌 정보가 없습니다.',
    DocumentsStatusCompleted: '제출 완료',
    DocumentsStatusReviewRequired: '검토 필요',
    DocumentsViewForm: '양식 확인',
    DocumentsSubmitRequiredQnaDocs: '필요 서류를 제출해주세요',
    DocumentsReviewYourDocs: '서류를 검토해주세요',
    ApplicationCollectingDocuments: 'Collecting Documents',
    DocumentsNoDocumentsRequested: '제출해야 할 서류가 없습니다',
    DocumentsHasBeenSigned: 'This document has been signed successfully!',
    FinishedWarningPopupTitle: '나중에 다시 진행하시겠어요?',
    FinishedWarningPopupDest: '서류 제출이 완료된 국가부터 출원서가 작성됩니다.',
    FinishedWarningPopupStay: '취소',
    FinishedWarningPopupContinue: '나중에 하기',
    Leave: '나중에 하기',

    LoginSuccessAndAutoSaved: '로그인에 성공했습니다! 신청서를 자동저장합니다.',
    DoYouWantToLeave: '신청서 작성을 중단하시겠어요? 입력한 내용을 잃게 됩니다.',
    // MyApplication: '내 신청내역',
    Applications: '신청서',
    ApplicationId: '신청서 ID',
    ApplicationCount: (count) => (
      <>
        <MDSTypography variant="T14">신청서</MDSTypography>
        <MDSTypography variant="T14" weight="medium">
          {count}
        </MDSTypography>
        <MDSTypography variant="T14">개</MDSTypography>
      </>
    ),
    NoApplications: '신청내역이 없습니다',
    SubmittedDateNewest: '제출일 (최신순)',
    SubmittedDateOldest: '제출일 (오래된순)',
    UpdatedDateNewest: '최종변경일 (최신순)',
    UpdatedDateOldest: '최종변경일 (오래된순)',
    LastSavedDate: '최종 저장일',
    SubmittedDate: '제출일',
    DateFormat: 'YYYY년 M월 D일',
    DateFormatSlash: 'MM/DD/YYYY',
    SeeDetail: '상세보기',
    Apply: '신청',
    ContractAndPayment: '견적 및 결제',
    EligibilityCheck: '조사중',
    PaymentRequested: '결제 요청',
    PaymentSuccess: '결제 완료',
    PaymentWaiting: '결제 대기중',
    PaymentFailed: '결제 실패',
    PaymentCanceled: '결제 취소',
    PaymentIncomplete: '결제 진행중',
    PaymentOverdue: '결제 기한 만료',
    Preparation: '출원 준비',
    File: '출원',
    Examination: '심사',
    FinalDecision: '최종 결정',
    Resume: '작성하기',
    FinalRejection: '최종 거절됨',
    PublishForOppposition: '특허청 공고중',
    OppositionPending: '이의신청 대응중',
    RegistrationGranted: '등록 결정됨',
    RegistrationCompleted: '등록 완료',
    Filed: '출원서 제출',
    UnderExamination: '특허청 심사중',
    PreliminarilyRejected: '중간 거절됨',
    AmendmentSubmitted: '보완서류 제출',
    AppealingRefusal: '거절 불복 심판중',
    OvercomingMarks: '선행상표 대응심판중',
    OvercameMarks: '선행상표 대응 성공',
    FailedMarks: '선행상표 대응 실패',
    // Apply: '신청',
    FilingPending: '출원 보류',
    ConfirmingApplication: '서류 준비',
    PreparingToFile: '출원 준비중',
    StatusOfCountryUpdated: (countries: string) => `${countries} 건의 상태가 변경되었습니다`,
    NewRequestFrom: (from: string, countries: string) =>
      `${countries ? `${countries} 관련 ` : ''}${from ? `${from}로부터 ` : ''}새로운 요청을 받았습니다`,
    Select: '선택',
    Enter: '입력',
    ApplicationStatus: '출원 상태',
    Request: '요청',
    invoice: '인보이스',
    NoNewRequest: '새로운 요청이 없습니다',
    DueDateClosest: '마감기한 (가까운순)',
    CreatedDate: '생성일',
    AdditionalInformation: '추가 정보',
    TrademarkClasses: '상품분류',
    ClassNumber: (number) => `제${number}류`,
    TrademarkUsageHistory: '상표 사용내역',
    AreYouSoldInUS: '해당 상표를 미국 상품 혹은 서비스에 사용하고 있나요?',
    WhenIsFirstInUs: '미국에서 처음 상업적으로 사용한 날이 언제인가요?',
    IDontKnow: '모름',
    WhenIsDateOfFirst: '국가와 관계없이 처음 상업적으로 사용한 날이 언제인가요?',
    ReplyAndAttachFile: '답변 및 파일 첨부하기',
    Reply: '답변하기',
    ChooseMultipleOption: '옵션 선택하기 (복수 선택)',
    ChooseAnOption: '옵션 선택하기',
    DueOn: (deadline, timezone) => `${deadline} ${timezone ? ` (${timezone})` : ''} 까지`,
    OverDue: (overdue: number) => `기한지남 (${overdue}일)`,
    Send: '전송',
    Sending: '전송중',
    Other: '기타',
    OtherDirect: '기타 (직접입력)',
    DateFormatWithTime: 'YYYY년 M월 D일 • hh:mm',
    YouCanOnlyAttachUpToNFiles: (max: number) => `최대 ${max}개 파일만 업로드할 수 있습니다`,
    YouCanAttachFile: (max: number) => `최대 ${max}개의 파일을 업로드해 주세요 (최대 파일당 20MB)`,
    ApplicationHasBeenUpdated: '신청서 내용이 수정되었습니다',
    LastEditedDate: '최종 수정일',
    Change: '변경',
    Save: '저장',
    Cancel: '이전',
    Logout: '로그아웃',
    Payment: '결제',
    SavedCreditOrDebitCards: '저장된 신용/체크카드',
    AddNewCreditOrDebitCard: '새로운 카드 추가',
    EndingInN: (n: string) => `**** ${n}`,
    AddNewCard: '새로운 카드 추가',
    PleaseEnterAValidCardNumber: '유효한 카드 번호를 입력해주세요',
    PleaseEnterAValidExpiryDate: '유효기간을 올바르게 입력해주세요',
    PleaseEnterAValidCVVNumber: '유효한 CVV를 입력해주세요',
    HowToFindYourCVVCVCHTML:
      'CVV/CVC 확인 방법<br/><br/>Visa, Mastercard, Discover, UnionPay는 카드 뒷면 서명 오른편에서 세 자리수 CVV/CVC를 확인하실 수 있습니다.<br/><br/>American Express는 카드 앞면에서 네 자리수 CVV를 확인하실 수 있습니다.',
    Delete: '삭제',
    WordTrademark: '문자 상표',
    LogoTrademark: '도형 상표',
    CompositeTrademark: '복합 상표',
    Consent: (evntTerms: () => void, eventPP: () => void) => (
      <>
        마크폴리오{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            evntTerms();
          }}
          style={{ color: MDSTheme.palette.blue[700] }}
        >
          이용약관
        </a>{' '}
        및{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            eventPP();
          }}
          style={{ color: MDSTheme.palette.blue[700] }}
        >
          개인정보 수집 및 이용
        </a>
        에 동의합니다.
      </>
    ),
    EmailVerified: '이메일 인증됨',
    PleaseCloseThisScreen: '이 화면을 닫고 MARQ Folio 화면으로 이동하여 인증을 완료해주세요.',
    Add: '추가',
    CompletePayment: '결제',
    TryAgain: '다시 시도',
    YourPaymentHasExpired: '결제 기한이 만료되었습니다. 다시 시도 후 기한 내 결제를 완료해주세요.',
    CountriesAndClasses: '국가 및 상품분류',
    OwnerAndInvoiceDetails: '상표권자 및 결제 정보',
    BillingDetails: '결제 정보',
    BillingDetailsMatch: '결제 정보와 상표권자 정보가 동일합니다',
    PermanentResidence: '배송지 주소',
    StreetAddress: '도로명',
    City: '시/군/구',
    ZipPostalCode: '우편 번호',
    PaymentMethod: '결제 수단',
    SelectYourPreferredPaymentMethod: '결제 수단을 선택해주세요',
    CreditOrDebitCard: '신용/체크카드',
    BankTransfer: '계좌 입금',
    Cardholder: '이름 (법인명)',
    CardNumber: '카드 번호',
    ExpirationDate: '유효기간',
    CVVCVC: 'CVV / CVC',
    SaveCardForLaterUse: '다음 결제를 위해 카드 정보 저장',
    PayN: (n: string) => `${n ? `${n} ` : ''}결제`,
    ByClickingTheXButtonJSX: (x: string, onTermsClick, onPrivacyClick) => (
      <>
        <div>{`“${x}” 버튼을 클릭함으로써`}</div>
        <div>
          <a href="#" onClick={onTermsClick}>
            {`이용약관`}
          </a>
          <span>&nbsp;및&nbsp;</span>
          <a href="#" onClick={onPrivacyClick}>
            {`개인정보처리방침`}
          </a>
          <span>에 동의합니다</span>
        </div>
      </>
    ),
    NewCreditOrDebitCard: '새로운 카드 추가',
    Summary: '견적',
    AbovePriceIsValidUntil: (d: string) => `${d}까지 유효한 견적입니다`,
    PlaceAnOrder: '주문하기',
    Order: '주문',
    AccountHolder: '예금주명',
    AccountNumber: '계좌 번호',
    AccountID: '신청서 ID',
    RoutingNumber: 'Routing number', // 영문 유지
    SwiftCode: 'SWIFT',
    BankName: '은행명',
    BankAddress: '주소',
    Copy: '복사',
    CopiedToClipboard: '클립보드에 복사되었습니다',
    ReferenceNumber: '입금 조회 번호',
    DueDate: '결제 마감일',
    DownloadInvoice: '인보이스 다운로드',
    YourTrademark: '상표',
    TypeOfTrademark: '상표 유형',
    ShowDetails: '상세 정보',
    HideDetails: '상세 정보 숨기기',
    Countries: '국가',
    Classes: '상품분류',
    Class: '상품분류',

    SendReport: '상표 조사 보고서',
    Contract: '인보이스',
    FilingSendReport: '출원예정보고서',
    FileDoneReport: '출원서',
    OaReport: 'OA 보고서',
    OaCaNoti: '답변서',
    OppReport: '출원공고 통지서',
    OppReqInfo: '이의신청 접수 및 대응전략보고서',
    OppReqDone: '이의신청 답변서',
    OppResultReport: '이의결정서',
    AppReport: '거절불복심판청구서',
    AppLose: '거절심결문',
    AppWin: '거절취소심결문',
    RejectReport: '거절결정통지 접수 및 대응안내보고서',
    RegReport: '등록결정서',
    RegDoneReport: '등록료납부확인서',
    RegElecReport: '전자등록증',
    CertSend: '등록증',
    CertAnnDone: '등록증 & 등록공고 통지서',
    RetrievalInfo: '이의/심판 청구예정보고서',
    RetrievalDone: '이의신청서/심판청구서',
    RetrievalReqReceive: '상대방 답변서',
    RetrievalReqDone: '재답변서',
    RetrievalWin: '이의/심판 승소심결문',
    RetrievalLose: '이의/심판 패소심결문',

    ConfirmedPrice: '확정 금액',
    DragAndDropFiles: '파일을 끌어서 놓거나 선택해주세요',
    Max20mb: '(최대 20MB)',
    ClickHereToBrowse: '파일을 선택해주세요',

    PaymentInvalidConflict: 'Invalidation of conflicting mark',
    Watch: '모니터링',
    WatchStartDate: '모니터링 시작일',
    GetStartedByAdding: '모니터링할 상표를 추가해보세요',
    BeAlertedWhenAThirdPartyTries:
      '제3자가 귀사의 상표와 유사하거나 동일한 상표를 출원하려고 할 시 알림을 받을 수 있습니다',
    AddNewTrademarkToWatch: '모니터링할 상표 추가',
    Table: '테이블뷰',
    TrademarkOverview: '상표 요약뷰',
    TmOverView: '상표 요약뷰',
    NewTrademark: '상표 추가',
    WatchCount: (count: number) => (
      <>
        <span>{count}</span>개 모니터링중
      </>
    ),
    NewTrademarkWatch: '모니터링할 상표 추가',
    EnterTrademarkName: '상표명을 입력해주세요',
    TrademarkName: '상표명',
    TrademarkImage: '상표 이미지 (로고)',
    CountryToWatch: '모니터링할 국가',
    SelectCountry: '국가를 선택해주세요',
    SelectWatchStartDate: '시작일을 선택해주세요',
    WatchPeriod: '모니터링 기간',
    SelectPeriod: '기간을 선택해주세요',
    ByCheckingTheBox: '체크 박스를 선택함으로써, 상표 모니터링 서비스 신청 및 그에 따른 개인정보 수집에 동의합니다',
    AddTrademarkToWatch: '모니터링 신청',
    DragAndDropOrBrowse: '파일을 끌어서 놓거나 선택해주세요',
    Period: '기간',
    Status: '상태 ',
    StatusDetails: '상세',
    YourRequestIsBeing: '신청서를 검토하고 있습니다. 곧 연락드리겠습니다.',
    EverythingLooksGreat: '발견된 위험이 없습니다',
    TakeAction: '위험 대응',
    RemindMeLater: '나중에 다시 알림 받기',
    WatchStartDateDesc: '모니터링 시작일 (최근순)',
    WatchStartDateAsc: '모니터링 시작일 (오래된순)',
    UrgencyDesc: '상태 (긴급한순)',
    OneMonths: '1개월',
    SixMonths: '6개월',
    OneYear: '1년',
    ThreeYear: '3년',
    WatchCancel: '취소',
    word: '문자 상표 ',
    logo: '로고 상표',
    composite: '복합 상표',
    designRight: '디자인권',
    ExpectedCompletion: '예상 등록일',
    ExpectedCompletionDescription: '예상 등록 일자이며, 사건 진행상황에 따라 변경될 수 있습니다',
    LogoMark: '로고 마크',
    FilingApplication: '출원',
    ApplicationInReview: '심사',
    AwaitingTrademark: '대응',
    TrademarkRegistered: '등록',
    RequestInProgress: '신청서 작성',
    EvaluationInProgress: '신청서 검토',
    WaitingForPayment: '결제 대기',
    PreparingApplication: '출원서 준비',
    ApplicationDrafted: '출원서 초안 검토',
    ApplicationDraftConfirmed: '출원서 초안 검토 완료',
    ApplicationFiled: '출원서 특허청 제출',
    PreliminarilyRefused: '중간 거절됨',
    DefendingRefusal: '중간사건 대응',
    PublishedForOpposition: '특허청 공고',
    ApplicationOpposed: '이의신청 대응',
    AppealingAgainstRejection: '거절불복 대응',
    RetrievingConflictingMarks: '선행상표 대응',
    RetrievingTradeMarks: '선행상표 대응',
    ConflictingMarksRetrieved: '선행상표 대응 성공',
    RetrievalFailed: '선행상표 대응 실패',
    WaitingForAdditionalPayment: '추가 결제 대기',
    AdditionalPaymentFailed: '추가 결제 실패',
    AdditionalPaymentCanceled: '추가 결제 취소',
    ApplicationRejected: '최종 거절됨',
    TrademarkApplication: '내 상표 출원',
    ReadMore: '더 보기',
    ShowLess: '숨기기',
    ContinueToBillingDetails: '결제 정보 입력',
    SignAndContinue: '서명 및 다음',
    SaveAndContinue: '저장 및 다음',
    Edit: '수정',

    OrderForm: '주문서',
    OrderFormDesc: '주문서 내용을 확인하고 서명해주세요',
    ConfirmFullName: '성함을 입력해주세요',
    ConfirmLegalName: '성함을 입력해주세요',
    OrderFormSign: (onClickTerms, onClickPP) => (
      <>
        "서명" 버튼을 클릭함으로써, (1) 본인(또는 대리인)이 위 기입한 성함을 전자 서명에 활용하고, (2){' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClickTerms();
          }}
        >
          이용약관
        </a>{' '}
        및{' '}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClickPP();
          }}
        >
          개인정보처리방침
        </a>{' '}
        에 동의합니다. 본 전자 서명은 법적 구속력 있는 모든 형태의 계약에 있어 서면 서명 및 이니셜 기입과 동일한 효력을
        발휘합니다.
      </>
    ),
    DoYouWantToLeavePayment: '결제를 중단하시겠어요? 입력한 내용을 잃게 됩니다.',

    PleaseSignIn: '계속하려면 로그인하세요',
    ToContinueTo: (pageName) =>
      `${pageName}${isEndWithConsonant(pageName) ? '을' : '를'} 계속하려면 로그인이 필요합니다`,
    ThisPage: '이 페이지',

    OppInfo: '이의/심판 안내',
    OppReq: '이의/심판청구 지시',
    OppDone: '이의/심판청구 완료',
    OppResp: '이의/심판청구 답변접수',
    OppRedo: '이의/심판청구 재답변지시',
    OppRedoDone: '이의/심판청구 재답변완료',
    ResultReceive: '결정/심결보고 접수',
  },
};

export default LocalizedStrings;
